const SapDomainData2 = [
  {
    sno: "1",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "On Premise",
    course_code:
      "ATCI-LTT-SAP-LT-BLC-0067, ATCI-LKM-SAP-LT-CR-0140, ATCI-LKM-SAP-LT-VT-0440, ATCI-LKM-SAP-LT-DGDK-0020",
    course_image: "img-5",
    course_name: "SAP ABAP on HANA",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to HANA</li>\r\n<li class='bullet-des-li'>Table Creation in HANA</li> \r\n<li class='bullet-des-li'>Attribute View, Analytical View</li> \r\n<li class='bullet-des-li'>Calculation View</li> \r\n<li class='bullet-des-li'>ABAP on HANA plug-in installation </li> \r\n<li class='bullet-des-li'>Open SQL</li>\r\n<li class='bullet-des-li'>CDS Views</li>\r\n<li class='bullet-des-li'>CDS Annotations</li></ul>",
    description:
      "This course covers\nIntroduction to HANA, Table Creation in HANA, Attribute View, Analytical View, Calculation View, ABAP on HANA plug-in installation, Open SQL, CDS Views, CDS Annotations, CDS to ODATA Service, External View, AMDP, AMDP BADI, ALV, Debugging/Migration tips, Stored Procedures, Functions",
    learning_path: "SAP ABAP on HANA Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "2 - 3 years ABAP (ECC) experience",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to:Explain the impact of HANA on ABAP development.Describe how to use ECLIPSE, SAP HANA Studio, and the ABAP Development Tools (ADT).Explain the tools used for modeling in HANA and describe how to model in HANA.Describe the HANA new developments, including how HANA uses OPEN SQL and the creation/consumption of CDS and AMDP.Describe the new tools available to developers and how to use them",
    "ssi_skill name": "SAP ABAP Development for HANA",
    "ssi_skill2 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9971/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "2",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Arch",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0025",
    course_image: "img-4",
    course_name: "SAP HANA Operations & Administration (1)",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP HANA Landscape</li> \r\n<li class='bullet-des-li'>SAP HANA Architecture </li> \r\n<li class='bullet-des-li'>SAP HANA Installation Scale-Out Scenarios</li>\r\n<li class='bullet-des-li'>Post-Installation</li> \r\n<li class='bullet-des-li'>Administrative Tools for SAP HANA Monitoring </li>\r\n<li class='bullet-des-li'>Troubleshooting Performance analysis</li> \r\n<li class='bullet-des-li'>Operations, Monitoring, Backup & Recovery,</li> \r\n<li class='bullet-des-li'> UHigh Availability & Disaster</li></ul>",
    description:
      "This course covers SAP HANA Landscape, SAP HANA Architecture ,HANA Installation, Scale-Out Scenarios, Post-Installation, Administrative Tools for SAP HANA, Troubleshooting Performance analysis Operations, Monitoring, Backup & Recovery, High Availability & Disaster Tolerance, Security, User Maintenance and Authorization, Multitenant Database Containers",
    learning_path: "SAP HANA Database Administration Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      "Knowledge of OS and DB Concept, SAP NW Application Server, SAP Basis",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Explain the importance and key features of SAP HANA, Discuss about the installation of SAP HANA and its deployment options, Explain the sizing techniques of SAP HANA, Explain the migration pre-requisites for SAP HANA, Explain the different architectural components of SAP HANA, Recognize how to use SAP HANA admin tools such as SAP HANA Studio, DBA Cockpit and SAP HANA Cockpit, Explain the database backup and recovery procedure in SAP HANA, Explain the monitoring and troubleshooting options offered by SAP HANA, Explain SAP HANA authorization and user/role creation for HANA Security, Explain the High Availability setup options and Disaster recovery measures offered by SAP HANA",
    "ssi_skill name": "SAP HANA DB Administration",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8672/rel-task/2997$10951.htmld",
    additional_url:
      "https://learning.sap.com/learning-journeys/installing-and-administering-sap-hana",
    "lead/poc": "Jagan",
    program_type: "Regular",
  },
  {
    sno: "3",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Procurement",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0003",
    course_image: "img-9",
    course_name: "SAP Ariba Boot Camp",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Ariba Overview</li>\r\n <li class='bullet-des-li'>Ariba Architecture and FPCR</li>\r\n<li class='bullet-des-li'>Purchase Orders</li> \r\n<li class='bullet-des-li'>Receiving Invoicing </li> \r\n<li class='bullet-des-li'>Invoice Workflow</li>\r\n <li class='bullet-des-li'> Ariba Network Communication</li> \r\n<li class='bullet-des-li'>Services Procurement </li>\r\n<li class='bullet-des-li'>Catalog Management </li></ul>",
    description:
      "This course covers Ariba Overview, Ariba Architecture – Federated Process Control, Requisitions. It also deals with purchase orders receiving, and invoicing. At the same time, it deals with invoice workflow, Ariba Network Communication and Services Procurement, catalog management, and user management. However, it deals with Ariba integration solution contract management, RFx, and Auction.",
    learning_path:
      "SAP Materials Management Learning Path / SAP SCM  Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "SAP MM, SAP SRM, S/4HANA Sourcing",
    Career_levels: "CL 7 to 12",
    duration: "45",
    mode: "Instructor Led / \r\nBlended",
    learning_outcomes:
      "At the end of this course , participants will be able to explain, Ariba Overview, Ariba Architecture – Federated Process Control, Requisitions, Purchase Orders, Receiving, Invoicing 8. Invoice Workflow, Ariba Network Communication, Services Procurement, Catalog Management, User Management, Ariba Integration Solution, Contract management, RFx and Auctions",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Ariba",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$4712/rel-task/2997$10951.htmld",
    additional_url:
      "https://open.sap.com/courses/sass1-sk\r\nhttps://www.ariba.com/resources/live-demos",
    remarks: "",
    "lead/poc": "Dinesh",
    program_type: "Regular",
  },
  {
    sno: "4",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Integration",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0047",
    course_image: "img-8",
    course_name: "SAP Process Integration",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP PI Components and Architecture</li>\r\n <li class='bullet-des-li'>SLD Overview,ESR Overview</li>\r\n<li class='bullet-des-li'>Integration Direct Overview</li>\r\n<li class='bullet-des-li'>Mapping Overview</li>\r\n<li class='bullet-des-li'>Monitoring and Administration</li>\r\n<li class='bullet-des-li'>Message Mapping</li>\r\n<li class='bullet-des-li'>Mapping Enhancement</li>\r\n<li class='bullet-des-li'>Folder Structure Concept</li></ul>",
    description:
      "This course covers SAP PI Components and Architecture,SLD Overview,ESR Overview.Integration Direct Overview,Mapping Overview,Monitoring and Administration,Message Mapping,Mapping Enhancement,Folder Structure Concept,XML Validation,eSOA Overview,ESR Modelling,Integration Flows,User Defined Message Search,ccBPM,PI and BPM,Roles in PI,Performance Tunning Basics,PI Migration Tool.",
    "Learning Path": "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      "ABAP, Java ,Fundamentals of SAP Web Application Server and Basic knowledge of Integration Technologies",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "40",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course, you will be able to work on end to end Process Integration Scenarios",
    ssi_skill_id: "80006292",
    "ssi_skill name": "SAP PO/PI & APIs Development",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9420/rel-task/2997$10951.htmld",
    lsc_link:
      "https://learning.sap.com/learning-journeys/discovering-sap-process-orchestration",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "5",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Procurement",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0002",
    course_image: "img-18",
    course_name: "SAP MM Boot Camp",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to SAP</li>\r\n <li class='bullet-des-li'>Explain the Org Structure with respect to Procurement Processes</li>\r\n<li class='bullet-des-li'>Introduction to Master data, Purchasing Info Record and Quota Arrangement</li>\r\n<li class='bullet-des-li'>Explain the functionality of Purchase Requisition</li>\r\n<li class='bullet-des-li'>Request For Quotation</li>\r\n<li class='bullet-des-li'>Purchase Order</li></ul>",
    description:
      "This course covers\nIntroduction to SAP, Explain the Org Structure with respect to Procurement Processes, Introduction to Master data, Purchasing Info Record and Quota Arrangement, Explain the functionality of Purchase Requisition, Request For Quotation, Purchase Order, Outline Agreements and External Services, Explain the concepts of Automatic Purchase Orders, Message Output types and Release Strategy, Concepts of Inventory Management, Understand Special Procurement Scenarios and Special Stocks, Explain Invoice Verification and Consumption Based Planning, Identify the standard reports provided by SAP.",
    learning_path: "SAP Materials Management Learning Path ",
    course_level: "Introductory",
    "pre-requisite": "Strong domain knowledge on procurement processes",
    Career_levels: "8,9,10,11",
    duration: "100",
    mode: "Blended / Instructor Led",
    learning_outcomes:
      "At the end of the course, participants will be able to: Explain SAP Materials Management (MM) functionality and how the module integrates with other modules, Describe the MM organization structure, master data, and common business transactions, Perform basic MM business transactions, Perform basic MM configuration",
    ssi_skill_id: "80004334",
    "ssi_skill name": "SAP MM Materials Management",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8282/rel-task/2997$10951.htmld",
    additional_url:
      "https://help.sap.com/doc/9e07b753128eb44ce10000000a174cb4/3.6/en-US/frameset.htm?frameset.htm",
    remarks:
      "Learning duration changed from 90 to 100 HRS as additioal topics added - 16 AUG 2024",
    "lead/poc": "Dinesh",
    program_type: "Regular",
  },
  {
    sno: "6",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Arch",
    landscape: "On Premise",
    course_code: "NA",
    course_image: "img-3",
    course_name: "SAP S/4HANA Technical Conversion & Migration",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>using Software Logistics Tool Set</li>\r\n <li class='bullet-des-li'>Maintenance Planner</li>\r\n<li class='bullet-des-li'>SAP S/4 HANA Installation SA S/4HANAupgrades</li>\r\n<li class='bullet-des-li'>Preparation activities and follow-up activities for an SAP S/4HANA conversion(System Conversion)</li>\r\n<li class='bullet-des-li'>preparation activities and follow-up activities for an SAP System upgrade (Upgrade)</li>\r\n<li class='bullet-des-li'>Using the Software Update Manager (SUM)</li>\r\n<li class='bullet-des-li'>Technical steps during an SAP S/4HANA conversion and an SAP system upgrade,Modification adjustments with SPDD and SPAU</li>\r\n<li class='bullet-des-li'>Downtime optimization,Troubleshooting,Upgrade of an SAP system landscape</li></ul>",
    description:
      "This course helps you to understand using Software Logistics Tool Set , Maintenance Planner ,SAP S/4 HANA Installation SA S/4HANAupgrades,Preparation activities and follow-up activities for an SAP S/4HANA conversion( System Conversion),preparation activities and follow-up activities for an SAP System upgrade (Upgrade),Using the Software Update Manager (SUM) ,Technical steps during an SAP S/4HANA conversion and an SAP system upgrade,Modification adjustments with SPDD and SPAU,Downtime optimization,Troubleshooting,Upgrade of an SAP system landscape,Principles of a Unicode conversion etc.",
    learning_path:
      "SAP S/4HANA Migration Learning Path,\nSAP S/4HANA Administration Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge on SAP Basis",
    Career_levels: "",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will understand SAP S/4HANA System conversion & Migration from SAP ECC to SAP S/4HANA ",
    "ssi_skill name": "SAP SLO Upgrades & Migrations",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$11802/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagan",
    program_type: "Regular",
  },
  {
    sno: "7",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Integration",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0018",
    course_image: "img-4",
    course_name: "SAP BTP Cloud Integration",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Details on SAP Cloud Integration and its benefits</li>\r\n <li class='bullet-des-li'>Provides the required information on the features of iPAAS (Integration Platform-As-A-Service)</li>\r\n<li class='bullet-des-li'>various Integration topics like Standard Packaged Content, Process Steps, Connectivity using different adapter like HTTPS, SOAP, OData, Mail, IDOC, SuccessFactors etc., Security, Transport, Monitoring and hands-on exercises</li></ul>",
    description:
      "This course provides details on SAP Cloud Integration and its benefits. It also provides the required information on the features of iPAAS (Integration Platform-As-A-Service). It also states the difference between Process and Data Integration. The course also covers various Integration topics like Standard Packaged Content, Process Steps, Connectivity using different adapter like HTTPS, SOAP, OData, Mail, IDOC, SuccessFactors etc., Security, Transport, Monitoring and hands-on exercises.",
    learning_path:
      "SAP S/4HANA Migration Learning Path,\nSAP S/4HANA Administration Learning Path",
    course_level: "",
    "pre-requisite":
      "SAP PO/PI & APIs Development/ SAP ABAP Development/ SAP UI5 Development/ SAP SuccessFactors Integrations Technical/SAP BTP Integration Suite/Any integration background",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "36",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Describe features of SAP Cloud  Integration, Explain SAP CPI – Process and data integration, Understand the development process, standard contents, security aspects, connectivity options, monitoring capabilities, pipeline steps for SAP CPI – PI and, develop integration scenarios in SAP CPI – PI ",
    ssi_skill_id: "80011681",
    "ssi_skill name": "SAP BTP Integration Suite",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8739/rel-task/2997$10951.htmld",
    additional_url:
      "https://help.sap.com/viewer/368c481cd6954bdfa5d0435479fd4eaf/Cloud/en-US/e12c09cc8e9b4574b092d8964b049ce6.html\nhttps://open.sap.com/courses/cp10/overview\nhttps://www.youtube.com/watch?v=Asc4-F0vEWU&list=PLkzo92owKnVy5gfh9etKt_TLkc-dM2l7t",
    lsc_link:
      "https://learning.sap.com/learning-journeys/discovering-sap-process-orchestration",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "8",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Warehousing",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLC-0060",
    course_image: "img-15",
    course_name: "SAP Warehouse Management",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>WM structure</li>\r\n<li class='bullet-des-li'>Master Data</li>\r\n<li class='bullet-des-li'>Integration with IM</li>\r\n<li class='bullet-des-li'>Integration with SD</li>\r\n<li class='bullet-des-li'>Integration with QM</li>\r\n<li class='bullet-des-li'>Goods Receipt</li>\r\n<li class='bullet-des-li'>Goods Issue</li>\r\n<li class='bullet-des-li'>Posting Changes</li></ul>",
    description:
      "This course covers\n- WM structure\n- Master Data\n- Integration with IM\n- Integration with SD\n- Integration with QM\n- Goods Receipt\n- Goods Issue\n- Posting Changes\n- PP Integration\n- Replenishment\n- Introduction to Mobile Data Entry (RFID)\n- Integration with External WMS Systems",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "Relevant domain knowledge",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "27",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this course, participanys will be able to Provide a process-based approach to SAP Warehouse Management (WM). Raise questions on how WM processes should be represented by an Enterprise Resource Planning System and learn how it is done with SAP\n",
    "ssi_skill name": "SAP Warehouse Management System (WMS)",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9874/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagadeesha",
    program_type: "Regular",
  },
  {
    sno: "9",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP Finance",
    landscape: "On Premise",
    course_code: "ATCI-LKM-SAP-LT-WB-0223",
    course_image: "img-17",
    course_name: "SAP S/4HANA Financial Accounting Bootcamp",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>S/4HANA overview</li>\r\n<li class='bullet-des-li'>Organizational Structures</li>\r\n<li class='bullet-des-li'>Master Data, like GL, BP, Bank and Assets</li>\r\n<li class='bullet-des-li'>Complete configuration activates in S/4HANA finance related components</li>\r\n<li class='bullet-des-li'>Overview of Controlling Module</li>\r\n</ul>",
    description:
      "This course covers\nS/4HANA overview, Organizational Structures, Master Data, like GL, BP, Bank and Assets and the complete configuration activates in S/4HANA finance related components, Overview of Controlling Module",
    learning_path: "SAP Finance Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Strong knowledge in Finance Domain",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "136",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to understand S/4 HANA Accountng Overview, Finance Organization structure, Basic Settings, GL Master data, Document Splitting, Exchange rate and GL Business Transaction Processing, understand the Accounts Payable & Accounts Receivable, Business Partner Master data, AP & AR Special GL and Regular Transactions,  Automatic Payment Program, Dunning Program, Correspondence and  MM, SD & FI Integration, understand  Controlling Overview and Basic settings and Overhead Allocation, understand Asset Accounting Org Structure & Master Data, Asset Accounting Depreciation, Asset Accounting Transactions and Asset Accounting Period End Closing, understand Financial Statements Period End Activity, Accounts Receivables and Payables Closing Activities, General Ledger Closing Activities and Financial Closing Cockpit.",
    ssi_skill_id: "80040882",
    "ssi_skill name": "SAP S/4HANA Finance",
    mylearning_url:
      "https://mylearning.accenture.com/mylearningui/learner/coursedetail/2002874",
    additional_url:
      "https://help.sap.com/doc/e931a357ce5ca30be10000000a44147b/3.6/en-US/88146d58284d0a02e10000000a44147b.html\nhttps://www.sap.com/products/s4hana-erp/features/finance.html",
    "Last updated Date": "9/11/2023",
    "Launched Date": "9/11/2023",
    "lead/poc": "Sateesh",
    program_type: "Regular",
  },
  {
    sno: "10",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Data",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0036",
    course_image: "img-15",
    course_name: "SAP Cloud Platform Integration for Data Services(CI DS)",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of Data Integration and Data Quality concepts</li>\r\n<li class='bullet-des-li'>Understanding CI DS architecture and components</li>\r\n<li class='bullet-des-li'>Creating and managing data flows and tasks</li>\r\n<li class='bullet-des-li'>Connecting to various source and target systems (SAP and non-SAP)</li>\r\n<li class='bullet-des-li'>Data extraction, transformation, and loading (ETL) processes</li></ul>",
    description:
      "This course covers\noverview of Data Integration and Data Quality concepts,\nunderstanding CI DS architecture and components, \nCreating and managing data flows and tasks, \nConnecting to various source and target systems (SAP and non-SAP), \nData extraction, transformation, and loading (ETL) processes",
    learning_path: "",
    course_level: "",
    "pre-requisite": "Any ETL skill,  Integration Skill , ABAP, IBP",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to understand CPI-DS Architecture, Difference between SAP DS and SAP CPI-DS, Agent Installation and configuration steps, IBP Introduction Master Data, How to use Standard templates, Monitoring, Promoting Tasks, Administration, troubleshooting, Best practices for CPI-DS",
    ssi_skill_id: "80026325",
    "ssi_skill name": "SAP CPI for Data Services",
    mylearning_url:
      "https://mylearning.accenture.com/mylearningui/learner/coursedetail/1523440/1782464",
    additional_url:
      "https://help.sap.com/doc/f710a11e51ac42d9bda8924f88d1121e/1.0.11.45/en-US/hci10_help_sap_en.pdf\nhttps://www.youtube.com/playlist?list=PLkzo92owKnVyHVtrzyF4KSQomTuKRg0q_",
    lsc_link:
      "https://learning.sap.com/learning-journeys/exploring-the-core-functions-in-sap-ibp",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "11",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Sales",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0058",
    course_image: "img-8",
    course_name: "SAP SD Boot Camp",
    bulleted_description:
      "<ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of Sales and Distribution Processes</li>\r\n<li class='bullet-des-li'>Organizational Structure</li>\r\n<li class='bullet-des-li'>Master Data and Transactional Processing</li>\r\n<li class='bullet-des-li'>Sales, Delivery, Shipment and Billing Processing</li>\r\n<li class='bullet-des-li'>Credit Management</li>\r\n<li class='bullet-des-li'> Pricing</li>\r\n<li class='bullet-des-li'> Output Determination</li>\r\n</ul>",
    description:
      "Participants will understand SAP SD concepts, functionalities and configuration\nTopics Include:\n• Key Concepts and Overview of the Sales and Distribution Processes\n• Organizational Structure\n• Master Data and Transactional Processing\n• Sales, Delivery, Shipment and Billing Processing\n• Credit Management\n• Pricing\n• Output Determination\n• Document Flow and Copy Control Settings\n• Returns Processing\n• SD Reporting\n• Integration aspects of SD with other modules",
    learning_path: "SAP Sales and Distribution Learning Path ",
    course_level: "Introductory",
    "pre-requisite": "Strong domain knowledge on sales and distribution",
    Career_levels: "8,9,10,11",
    duration: "45",
    mode: "Blended / Instructor Led",
    learning_outcomes:
      "At the end of this course, participants will be able to \nProvide a process-based approach to SAP Sales & Distribution (SD),\nDescribe the meaning, function and role of Sales,\nRaise questions on how Sales and Distribution processes should be represented by an Enterprise Resource Planning System and learn how it is done with SAP,\nDescribe specific features of SAP SD, limits and challenges in order to cope with all-day customer‘s concerns,\nEstablish a base for further specialization (personal skill development),\nFocus on application-level, therefore Customizing and System configuration are handled separately",
    "ssi_skill name": "SAP Sales and Distribution (SD)",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9894/rel-task/2997$10951.htmld",
    additional_url:
      "https://help.sap.com/viewer/af093ec4fc3241be85e76ed4c23b4073/6.00.31/en-US",
    "lead/poc": "Dinesh",
    program_type: "Regular",
  },
  {
    sno: "12",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Arch",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLC-0033",
    course_image: "img-17",
    course_name: "SAP OS/DB Migration Training",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP System Migration - Overview </li>\r\n<li class='bullet-des-li'>SAP Migration Tools </li>\r\n<li class='bullet-des-li'>Export and Import of System Copies</li> \r\n<li class='bullet-des-li'>Control and Data File Structure for ABAP, JAVA</li>\r\n<li class='bullet-des-li'>Advance Migration tool & Technique</li>\r\n<li class='bullet-des-li'>The System Migration Process, Hands-on session</li>\r\n<li class='bullet-des-li'>Troubleshooting</li> \r\n</ul>",
    description:
      "This course covers\n• SAP System Migration - Overview \n• SAP Migration Tools \n• Export and Import of System Copies \n• Control and Data File Structure for ABAP & JAVA System Copies \n• Advance Migration tool & Technique \n• The System Migration Process - Hands-on session \n• Troubleshooting \n• Special System Copy Procedures",
    learning_path: "SAP S/4HANA Migration Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      "Knowladge on SAP Basis administration, SAP system installation, SAP Database administration, OS Administration",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will understand SAP OS/DB migration technical pre-requisites, Migration Tools, Migration Methodology,SAP OS/DB migration service , SAP system export and Import using SAP tools like R3load /Jload, Different kind of control files involved in SAP OS/DB migration, Advance Migration Techniques & Optimization.  ",
    "ssi_skill name": "SAP HANA DB Migration & Upgrades",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9096/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "13",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Development",
    landscape: "On Premise",
    course_code: "NA",
    course_image: "img-8",
    course_name: "SAP S/4HANA Embedded Analytics",
    bulleted_description:
      " This Course covers\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>operational analytics tools</li>\r\n<li class='bullet-des-li'>data model used in S4HANA embedded analytics</li>\r\n<li class='bullet-des-li'>Embedded Analytics Overview</li>\r\n<li class='bullet-des-li'>Architecture, CDS views overview</li>\r\n<li class='bullet-des-li'>Integration with SAP Analytics Cloud</li>\r\n<li class='bullet-des-li'>Query Browser, View Browser, Analytical Queries</li>\r\n<li class='bullet-des-li'>Analysis Path Framework (APF)</li>\r\n<li class='bullet-des-li'>Multi Dimensional Report, KPI Framework, Overview Page</li>\r\n<li class='bullet-des-li'>Analytical List Page (ALP), SAP Lumira, and Analysis for Office</li></ul>",
    description:
      "This course provides an inclusive view on the real- time, operational analytics tools and data model used in S4HANA embedded analytics. It provides comprehensive details on Embedded Analytics Overview, Architecture, CDS views overview, Integration with SAP Analytics Cloud, and Business Intelligence tools. It gives details on Embedded Analytics tools, Query Browser, View Browser, Analytical Queries, Analysis Path Framework (APF), Multi Dimensional Report, KPI Framework, Overview Page, Analytical List Page (ALP), SAP Lumira, and Analysis for Office.",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Basic Analytics Knowledge",
    Career_levels: "",
    duration: "50",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to work on SAP SAP S/4HANA Embedded Analytics.",
    ssi_skill_id: "80018934",
    "ssi_skill name": "SAP Embedded Analytics Development",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$14016/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "14",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP Finance",
    landscape: "",
    course_code: "",
    course_image: "img-10",
    course_name: "SAP S/4HANA Central Finance",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Central Finance Overview</li>\r\n<li class='bullet-des-li'>Central Finance Architecture & Activities at glance</li>\r\n<li class='bullet-des-li'>SLT Replication Server</li>\r\n<li class='bullet-des-li'>Central Finance Setup & Configuration of Target System, Business Mapping and Source System</li>\r\n<li class='bullet-des-li'>Central Finance Initial Load</li>\r\n<li class='bullet-des-li'>Central Finance Real Time Replication</li>\r\n<li class='bullet-des-li'>Error Handling - AIF</li>\r\n<li class='bullet-des-li'>Central Finance Reporting, Limitations & Roadmap</li>\r\n</ul>",
    description:
      "This course covers\n•\nCentral Finance Overview\n•\nCentral Finance Architecture & Activities at glance\n•\nSLT Replication Server\n•\nCentral Finance Setup & Configuration of Target System, Business Mapping and Source System\n•\nCentral Finance Initial Load\n•\nCentral Finance Real Time Replication\n•\nError Handling - AIF\n•\nCentral Finance Reporting, Limitations & Roadmap",
    learning_path: "SAP Finance Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Work experience on FICO / S4 Hana Finance",
    Career_levels: "",
    duration: "20",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand central finance overview, landscape, deployment options, different scenarios, and benefits.Understand the central finance architecture, activities in CFIN project, system architecture along activities.Understand SLT - what is it, what does it, how does it work and deployment options.Understand technical & functional pre-requisites, configuration of target system, business mapping - concept, actions, target system mapping, source system configuration and possible scenarios.Understand initial load overview, cost objects, FICO postings and co secondary postings.Understand replication of FICO documents.Understand application interface framework and it's features.Understand reporting overview, reconciliation, additional enhancements, and new innovations.",
    ssi_skill_id: "80018711",
    "ssi_skill name": "SAP FI S/4HANA Central Finance",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$11888/rel-task/2997$10951.htmld",
    additional_url: "",
    "Last updated Date": "",
    "Launched Date": "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "15",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP Reporting",
    landscape: "On Premise",
    course_code: "NA",
    course_image: "img-2",
    course_name: "SAP S/4HANA Revenue Accounting and Reporting",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'> SAP RAR Introduction & Overview</li>\r\n <li class='bullet-des-li'>SAP RAR Master Data Management</li>\r\n<li class='bullet-des-li'>SAP RAR Migration and Transition</li>\r\n<li class='bullet-des-li'>SAP RAR - Reporting</li></ul>",
    description:
      "This Course Covers SAP RAR Introduction & Overview, SAP RAR Master Data Management, SAP RAR Migration and Transition and SAP RAR - Reporting",
    learning_path: "SAP Finance Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Work experience on FICO / S4 Hana Finance",
    Career_levels: "",
    duration: "8",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will understand SAP RAR (Revenue Accounting and Reporting) with IFRS 15, understanding the 5 steps frameworks (Revenue Calculation) for IFRS 15, key Changes Introduced by IFRS 15, role of SAP RAR in Addressing IFRS 15 Requirements, features and Functionality of SAP RAR for IFRS 15 Compliance, implementation considerations for SAP RAR and IFRS 15, configuration and customization Options in SAP RAR, integration with other SAP Modules for seamless compliance, case studies: successful implementations of SAP RAR for IFRS 15, monitoring and reporting Capabilities in SAP RAR",
    ssi_skill_id: "80015145",
    "ssi_skill name": "SAP Revenue Accounting and Reporting ERPP",
    mylearning_url: "",
    additional_url: "",
    "Last updated Date": "",
    "Launched Date": "",
    "lead/poc": "Sateesh",
    program_type: "Regular",
  },
  {
    sno: "16",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP Finance",
    landscape: "On Premise",
    course_code: "ATCI-LKM-SAP-LT-CR-0232",
    course_image: "img-16",
    course_name: "SAP Flexible Real Estate Management training",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction, Master Data, Contract Management & Additional Functionality</li>\r\n <li class='bullet-des-li'>RE-FX Accounting</li>\r\n<li class='bullet-des-li'>RE-FX Balance Sheet Valuation & Scenarios</li>\r\n<li class='bullet-des-li'>RE-FX Reporting</li>\r\n<li class='bullet-des-li'>RE-FX Configuration</li></ul>",
    description:
      "Introduction, Master Data, Contract Management & Additional Functionality RE-FX Accounting RE-FX Balance Sheet Valuation & Scenarios RE-FX Reporting RE-FX Configuration ",
    learning_path: "Process Discipline and Controls in SAP Cash Management",
    course_level: "Intermediate",
    "pre-requisite": "Strong knowledge in Finance Domain",
    Career_levels: "",
    duration: "40",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand Introduction, Master Data, Contract Management & Additional Functionality, Understand RE-FX Accounting, Understand RE-FX Balance Sheet Valuation & Scenarios, Understand RE-FX Reporting, Understand RE-FX Configuration",
    ssi_skill_id: "80009185",
    "ssi_skill name": "SAP Flexible Real Estate Management (RE-FX)",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9917/rel-task/2997$10951.htmld",
    additional_url: "",
    "Last updated Date": "7/17/2024",
    "Launched Date": "7/17/2024",
    "lead/poc": "Sateesh",
    program_type: "Regular",
  },
  {
    sno: "17",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "on cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0019",
    course_image: "img-15",
    course_name: "SAP Cloud Application Programming Model (CAPM)",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Modeling applications using Core Data Services (CDS)</li>\r\n <li class='bullet-des-li'>Rest client usage</li>\r\n<li class='bullet-des-li'>Creating custom handlers</li>\r\n<li class='bullet-des-li'>Annotations from CAP projects</li>\r\n<li class='bullet-des-li'>Consuming External services from CAPM</li>\r\n<li class='bullet-des-li'>Deploying CAP projects on HANA DB</li></ul>",
    description:
      "In this course, you will learn modeling applications using Core Data Services (CDS) and connect them to  SQLite database and SAP HANA. You will learn Associations, Rest client usage, Creating custom handlers, Annotations from CAP projects, Consuming External services from CAPM, Deploying CAP projects on HANA DB, Custom CDS types, Consuming Business Hub APIs, Various OData Functionalities like Association& Navigation in ODATA, Select Statement in ODATA, Excluding, Including properties and ETag properties in OData. You will understand CAP project development using Business Application Studio.",
    learning_path: "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      "JavaScript/Node.js/Advance Front End Development Node.js/SAP UI5 Development/Java Full Stack Development /SAP ABAP Development/SAP BTP Extension Suite",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "60",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to develop applications using Cloud Application Programming Model",
    ssi_skill_id: "80024176",
    "ssi_skill name": "SAP BTP Application Development",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8900/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "18",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP DB",
    landscape: "on cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0040",
    course_image: "img-16",
    course_name: "SAP HANA Cloud Development",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of BTP and HANA Cloud</li>\r\n <li class='bullet-des-li'>Developing Applications with HANA Cloud</li>\r\n<li class='bullet-des-li'>Basic Development tools used for development</li>\r\n<li class='bullet-des-li'>Implementing Smart Data Integration with HANA Cloud</li>\r\n<li class='bullet-des-li'>Creating HANA objects by using HANA DB</li></ul>",
    description:
      "In this course you will learn basic concepts of BTP and HANA Cloud, Developing Applications with HANA Cloud, Basic Development tools used for development, Implementing Smart Data Integration with HANA Cloud, and creating HANA objects by using HANA DB explorer and Business Application Studio. ",
    learning_path: "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      " HANA Modeling and Development , BW on HANA, BW/4 HANA, ABAP,Any database skill",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will gain knowledge on developing obejcts using HANA Cloud",
    ssi_skill_id: "80025384",
    "ssi_skill name": "SAP HANA Cloud",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9425/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "19",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Procurement",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0004",
    course_image: "img-18",
    course_name: "OpenText Vendor Invoice Management (VIM) for SAP Solutions",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Describe the overview and advantages of SAP VIM</li>\r\n<li class='bullet-des-li'>Understand the Archive Server and ICC</li>\r\n<li class='bullet-des-li'>Describe the SAP VIM Configuration</li>\r\n<li class='bullet-des-li'>Describe Complete Business flow in SAP VIM </li></ul>",
    description:
      "At the end of this course, participants will be able to\n•\nDescribe the overview and advantages of SAP VIM\n•\nUnderstand the Archive Server and ICC\n•\nDescribe the SAP VIM Configuration\n•\nDescribe Complete Business flow in SAP VIM ",
    learning_path: "SAP Materials Management Learning Path ",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge of SAP MM and Basic FI ",
    Career_levels: "7,8,9,10,11",
    duration: "36",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to\n•\nDescribe the overview and advantages of SAP VIM\n•\nUnderstand the Archive Server and ICC\n•\nDescribe the SAP VIM Configuration\n•\nDescribe Complete Business flow in SAP VIM ",
    "ssi_skill name": "SAP Vendor Invoice Management",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8292/rel-task/2997$10951.htmld",
    additional_url:
      "https://www.opentext.com/products-and-solutions/products/opentext-suite-for-sap/opentext-vendor-invoice-management-for-sap-solutions",
    "lead/poc": "Dinesh",
    program_type: "Regular",
  },
  {
    sno: "20",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP DB",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0021",
    course_image: "img-19",
    course_name: "SAP HANA Modeling and Native development",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Overview on core capabilities of SAP HANA</li>\r\n <li class='bullet-des-li'>Details on Core Data Services</li>\r\n<li class='bullet-des-li'>Developing content using SAP Web IDE for SAP HANA</li>\r\n<li class='bullet-des-li'>Details on data access security in a modeling context</li>\r\n<li class='bullet-des-li'>Store procedures, Synonyms, Functions, Triggers and HANA XSODATA and XSJS queries</li></ul>",
    description:
      "This course provides details on the core capabilities of SAP HANA for calculation view modeling and covers mainly graphical modeling. It also gives details on Core Data Services. Participants will gain knowledge on developing content using SAP Web IDE for SAP HANA and also get details on data access security in a modeling context. This course helps to develop SAP HANA Native objects like Store procedures, Synonyms, Functions, Triggers and HANA XSODATA and XSJS queries",
    learning_path: "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "BW on HANA, BW/4 HANA, ABAP, Any database skill",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "50",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to: Work on HANA Modelling Concepts, Work on Native HANA Apps",
    ssi_skill_id: "80009558",
    "ssi_skill name": "SAP Native HANA SQL Modeling & Development",
    ssi_skill2_id: "80025366",
    "ssi_skill2 name": "SAP HANA Extended Application Services",
    ssi_skill3_id: "80013630",
    "ssi_skill3 name": "SAP HANA SQL Scripts Development",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8939/rel-task/2997$10951.htmld",
    additional_url:
      "https://help.sap.com/viewer/400066065a1b46cf91df0ab436404ddc/2.0.00/en-US/d3382069b5314733b79520889332d4a6.html\nhttps://help.sap.com/viewer/fc5ace7a367c434190a8047881f92ed8/2.0.02/en-US\nhttps://www.youtube.com/watch?v=j-LFppxTIJo&list=PLkzo92owKnVz9hgx4CzW0Nc2ocU7riEMr",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "21",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Integration",
    landscape: "on cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0097",
    course_image: "img-1",
    course_name: "SAP BTP API Management",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP BTP Integration Suite and its capability API Management</li>\r\n <li class='bullet-des-li'>Creation of API Proxy</li>\r\n<li class='bullet-des-li'>Products and applications</li>\r\n<li class='bullet-des-li'>Masking Sensitive Data on APIs</li>\r\n<li class='bullet-des-li'>Applying different Policies like SQL Injection</li></ul>",
    description:
      "This course covers the SAP BTP Integration Suite and its capability API Management. In this course standard API walk through, creation of API Proxy, Products and applications, monetization and monitoring of APIs is covered. Applying different Policies like SQL Injection, API verification, Masking Response URL and Masking Sensitive Data on APIs along with creation of Policy templates. API Business Hub Enterprise portal and respective concepts are also covered.",
    learning_path: "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Good to have basic knowledge on API",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "18",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of the course you will be able to understand  different aspects of SAP API Management, pre-packaged content, provider systems, custom API creation, monetization, and test console.",
    ssi_skill_id: "80011681",
    "ssi_skill name": "SAP BTP Integration Suite",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10865/rel-task/2997$10951.htmld",
    lsc_link:
      "https://learning.sap.com/learning-journeys/modernizing-integration-with-sap-integration-suite",
    additional_url: "",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "22",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP User Experience",
    landscape: "on Cloud & on premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0020",
    course_image: "img-13",
    course_name: "SAP UI5 and Fiori Applications  Development",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to SAP BAS</li>\r\n<li class='bullet-des-li'>Create SAP UI5 application using SAP BAS</li>\r\n<li class='bullet-des-li'>Creating SAP UI5 application using CSS, JSON</li>\r\n<li class='bullet-des-li'>Consume OData in SAP UI5 app using SAP BAS </li> </ul>",
    description:
      "This course covers:\n• Introduction to SAP BAS\n•Create and deploy SAP UI5 application using SAP BAS\n•Create SAP UI5 application based on master detail template and List report.\n•Creating SAP UI5 application using CSS,JSON,Resource model and data binding concept\n•Consume odata in SAP UI5 application using SAP BAS. \n• Smart control,Custom control and Google map API usage in SAP UI5 application,  Deploying Apps, ABAP Programming models for Fiori, Fiori Introduction, Developing apps using Fiori Elements",
    learning_path: "SAP UI5 Leaning Path",
    course_level: "Intermediate",
    "pre-requisite": "JavaScript, HTML5, CSS, ABAP,Java ",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "50",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to develop UI5 applications using Business Application Studio and work on Fiori Launchpad Configuration.",
    ssi_skill_id: "80011389",
    "ssi_skill name": "SAP UI5 Development",
    ssi_skill2_id: "80011387",
    "ssi_skill2 name": "SAP FIORI/Gateway architecture",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8758/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link:
      "https://learning.sap.com/learning-journeys/learn-the-basics-of-sap-fiori",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "23",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "on Cloud & on premise",
    course_code: "",
    course_image: "img-19",
    course_name: "SAP ABAP RESTful Application Programming(VT)",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Concepts of RAP, RAP architecture</li>\r\n<li class='bullet-des-li'>RAP architecture</li>\r\n<li class='bullet-des-li'>Development of end-to-end simple application</li>\r\n<li class='bullet-des-li'>Development of end-to-end application with transactional behavior</li>\r\n<li class='bullet-des-li'>Extracting metadata from CDS</li></ul>",
    description:
      "This course covers Concepts of RAP, RAP architecture, Development of end-to-end simple application, Development of end-to-end application with transactional behavior, Extracting metadata from CDS",
    learning_path: "SAP ABAP on HANA Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Hands-on experience on ABAP on HANA",
    Career_levels: "",
    duration: "27",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of the course you will be able to:Explain the concepts of RAP, Explain the RAP architecture, Develop end-to-end simple application, Develop end-to-end application with transactional behavior, Extract metadata from CDS",
    "ssi_skill name": "SAP ABAP Development for HANA",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10117/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Dhiren",
    program_type: "Regular",
  },
  {
    sno: "24",
    type: "Technology",
    platform: "SAP",
    domain: "SAP HR",
    specialization: "SAP HCM",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0024",
    course_image: "img-3",
    course_name: "SAP HCM Functional",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Enterprise Structure </li>\r\n<li class='bullet-des-li'>Personnel Administration, and Organizational Management</li>\r\n<li class='bullet-des-li'>Time Management & Time Evaluation</li>\r\n<li class='bullet-des-li'>CATS - Timesheet</li>\r\n<li class='bullet-des-li'>Payroll Management, Compensation and Benefit</li>\r\n<li class='bullet-des-li'>Travel Management</li>\r\n</ul>",
    description:
      "This course covers Enterprise Structure Personal Administration, Personnel Management, Organizational Management Time Management & Time Evaluation CATS - Timesheet Payroll Management, Compensation and Benefit Travel Management Training and Event Management Information Types & Dynamic Action",
    learning_path: "HR Learning Path",
    course_level: "Introductory",
    "pre-requisite": "Strong HR domain knowledge",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "45",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to understand the various processes in SAP HR module like Personnel Administration , Talent Management, Time Management, Payroll, Organizational Management,Reporting, Training & Event Management, Travel Management etc.,",
    "ssi_skill name":
      "SAP HCM Personnel Administration, SAP HCM Organizational Management",
    ssi_skill2_id: "",
    "ssi_skill2 name": "SAP HCM Time Management",
    ssi_skill3_id: "",
    "ssi_skill3 name": "SAP HCM Payroll",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9043/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagan",
    program_type: "Regular",
  },
  {
    sno: "25",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Finance",
    landscape: "",
    course_code: "NA",
    course_image: "img-11",
    course_name: "SAP S/4Hana Management Accounting",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Controlling Overview & Basic Settings/li>\r\n <li class='bullet-des-li'>Cost center accounting</li>\r\n<li class='bullet-des-li'>Internal Orders Management</li>\r\n<li class='bullet-des-li'>Product Costing</li>\r\n<li class='bullet-des-li'>Material Ledger Accounting</li>\r\n<li class='bullet-des-li'>Profit center accounting</li>\r\n<li class='bullet-des-li'>Profitability Analysis</li></ul>",
    description:
      "This course Covers:- Controlling Overview & Basic Settings - Cost center accounting - Internal Orders Management - Product Costing - Material Ledger Accounting - Profit center accounting - Profitability Analysis",
    learning_path: "SAP Finance Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Strong knowledge in Finance Domain",
    Career_levels: "",
    duration: "40",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand Controlling Overview & Basic Settings.Understand Cost Center Accounting.Understand Internal Orders Management.Understand Product Costing.Understand Material Ledger Accounting.Understand Profit center accounting.Understand Profitability Analysis",
    ssi_skill_id: "",
    "ssi_skill name": "SAP CO Management Accounting",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10032/rel-task/2997$10951.htmld",
    additional_url: "",
    "Last updated Date": "",
    "Launched Date": "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "26",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Arch",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0038",
    course_image: "img-11",
    course_name: "SAP Data Archiving & ILM",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of SAP Data Archiving</li><li class='bullet-des-li'>Data Archiving Process</li><li class='bullet-des-li'>Residence & Retention Period Definition</li><li class='bullet-des-li'>Overview of NLS (Near Line Storage)</li><li class='bullet-des-li'>Overview of SAP ILM</li><li class='bullet-des-li'>Difference between SAP ILM & Data Archiving</li><li class='bullet-des-li'>Basic Concepts of SAP ILM</li><li class='bullet-des-li'>Retention Management in SAP ILM</li></ul>",
    description:
      "This course covers the below topics Overview of SAP Data Archiving Data Archiving Process  Residence & Retention Period Definition NLS (Near Line Storage)  SAP ILM Difference between SAP ILM & Data Archiving Concepts of SAP ILM Retention Management in SAP ILM LM Audit Area, Policy & Rule Creation",
    learning_path: "SAP Business Suite on HANA Learning Path",
    course_level: "Introductory",
    "pre-requisite": "Basic knowledge of SAP BASIS",
    Career_levels: "",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to plan and implement SAP Data archiving  & ILM methodology in a project.",
    "ssi_skill name": "SAP Information Lifecycle management ILM",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9473/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "27",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Arch",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0023",
    course_image: "img-18",
    course_name: "SAP Basis Bootcamp",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP NW 7.5 AS ABAP on HANA Installation</li>\r\n <li class='bullet-des-li'>Post Installation of SAP HANA & ECC on HANA</li>\r\n<li class='bullet-des-li'>Administer HANA Database using HANA Admin Tools</li>\r\n<li class='bullet-des-li'>Change & Transport Management</li>\r\n<li class='bullet-des-li'>Overview of SAP S/4HANA </li>\r\n<li class='bullet-des-li'>SAP Monitoring tools</li></ul>",
    description:
      "This course covers\n•SAP NW 7.5 AS ABAP on HANA Installation, Post Installation of SAP HANA & ECC on HANA, User Administration, Client Administration, Output Management, Backgroung Job Administratio, Operation Modes, Background Job Administration,RFC Connections, Change & Transport Management , System Monitoring , Administer HANA Database using HANA Admin Tools , SAP Monitoring tools, Overview of SAP S/4HANA ",
    learning_path: "SAP Business Suite on HANA Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge on OS , DB & Networking Concepts",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "45",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will learn to administer the SAP systems (AS ABAP System).",
    "ssi_skill name": "SAP BASIS Administration",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8988/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagan",
    program_type: "Regular",
  },
  {
    sno: "28",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Sales",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0004",
    course_image: "img-17",
    course_name: "SAP Global Trade Services",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'> Introduction to GTS </li><li class='bullet-des-li'> ECC- GTS integration </li><li class='bullet-des-li'> Risk- Preference </li><li class='bullet-des-li'> Management Letter of credit/Restitution (Theory) </li><li class='bullet-des-li'> Customs-Export Customs-Import Compliance- </li><li class='bullet-des-li'> SPL Compliance -Embargo, </li><li class='bullet-des-li'> Legal Control Special Customs Procedures, </li><li class='bullet-des-li'> Transit (Theory) Electronic Compliance Reporting</li></ul>",
    description:
      "This course covers\n- Introduction to GTS \n- ECC- GTS integration \n- Risk- Preference \n- Management Letter of credit/Restitution (Theory) \n- Customs-Export Customs-Import Compliance- \n- SPL Compliance -Embargo, \n- Legal Control Special Customs Procedures, \n- Transit (Theory) Electronic Compliance Reporting\n",
    learning_path: "SAP Sales and Distribution Learning Path",
    course_level: "Intermediate",
    "pre-requisite": " SAP MM, SAP SD  , SAP TM",
    Career_levels: "7,8,9,10,11",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will understand Introduction to GTS ECC- GTS integration Risk- Preference Management Letter of credit/Restitution (Theory) Customs-Export Customs-Import Compliance- SPL Compliance -Embargo, Legal Control Special Customs Procedures, Transit (Theory) Electronic Compliance Reporting",
    "ssi_skill name": "SAP Global Trade Services",
    ssi_skill2_id: "",
    "ssi_skill2 name": "SAP MM Materials Management",
    ssi_skill3_id: "",
    "ssi_skill3 name": "SAP Sales and Distribution (SD)",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8442/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "",
    remarks: "",
    program_type: "",
  },
  {
    sno: "29",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Manufacturing",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0045",
    course_image: "img-2",
    course_name: "SAP S/4HANA Production Planning Bootcamp",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>ERP Organizational Structure</li><li class='bullet-des-li'>Introduction to Manufacturing</li><li class='bullet-des-li'>Production Planning Master Data</li><li class='bullet-des-li'>Overview of IBP</li><li class='bullet-des-li'>Material Requirement Planning overview (MRP)</li><li class='bullet-des-li'>Production planning  functionality and Fiori apps in S/4HANA</li><li class='bullet-des-li'>Fiori apps for PP </li></ul>",
    description:
      "1. ERP Organizational Structure\n2. Introduction to Manufacturing\n3. Production Planning Master Data\n4. ales and Operations Planning\n5. Demand Management\n6. Overview of IBP\n7. Material Requirement Planning overview (MRP)\n8. Discrete Manufacturing\n9. PP-PI Manufacturing\n10. Batch Management\n11. Repetitive Manufacturing\n12. Production planning  functionality and Fiori apps in S/4HANA\n13. Fiori apps for PP ",
    learning_path: "Manufacturing",
    course_level: "Intermediate",
    "pre-requisite": "Strong knowledge in SAP MM or SAP SD or SAP PP ",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "45",
    mode: "Blended",
    learning_outcomes:
      "The participants would get the complete knowledge on SAP PP and would be ready to work in projects with SAP PP and as well on Implementation projects.",
    ssi_skill_id: "80013951",
    "ssi_skill name": "SAP PP Production Planning & Control Process Industries",
    ssi_skill2_id: "80013906",
    "ssi_skill2 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9535/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagadeesha",
    program_type: "Regular",
  },
  {
    sno: "30",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Manufacturing",
    landscape: "On Premise",
    course_code: "ATCI-LKM-SAP-LT-CR-0061 , ATCI-LTT-SAP-LT-BLC-0062",
    course_image: "img-3",
    course_name: "SAP Quality Management(QM)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction Quality Management</li><li class='bullet-des-li'> QM Master Data</li><li class='bullet-des-li'> QM in Pr. ocurement & Production </li><li class='bullet-des-li'> QM In Sales & Inventory</li><li class='bullet-des-li'> Quality certificates</li><li class='bullet-des-li'> Stability study</li><li class='bullet-des-li'> Quality Notification's</li><li class='bullet-des-li'> Integration&nbsp</li></ul>",
    description:
      "1. Introduction Quality Management\n2. QM Master Data\n3. QM in Pr. ocurement & Production \n4. QM In Sales & Inventory\n5. Quality certificates\n6. Stability study\n7. Quality Notification's\n8. Integration \n",
    learning_path: "Manufacturing",
    course_level: "Intermediate",
    "pre-requisite": "Strong Knoweldge on SAP MM or SAP SD or SAP PP",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "18, 45",
    mode: "Instructor Led",
    learning_outcomes:
      "The praticipants would gain the required knowledge on SAP QM and would be able to work in the support and implementation projects",
    ssi_skill_id: "80013907",
    "ssi_skill name": "SAP Quality Management (QM)",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9953/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagadeesha ",
    program_type: "Regular",
  },
  {
    sno: "31",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Manufacturing",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0063",
    course_image: "img-5",
    course_name: "SAP S/4 HANA Transportation management",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to SAP TM</li><li class='bullet-des-li'>Business Process</li><li class='bullet-des-li'>ERP and TM Orga Structure</li><li class='bullet-des-li'>ERP and TM Master Data</li><li class='bullet-des-li'>ERP and TM integration</li><li class='bullet-des-li'>Shipper Scenario Demo</li></ul>",
    description:
      "1.Introduction to SAP TM\n2. Business Process\n3 .ERP and TM Orga Structure\n4. ERP and TM Master Data\n5. ERP and TM integration\n6. Shipper Scenario Demo",
    learning_path: "Logistics",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge of SAP MM or SD or PP or EWM or GTS",
    Career_levels: "7,8,9,10,11",
    duration: "16",
    mode: "Instructor Led",
    learning_outcomes:
      "Participants would understand the business concepts, Org Structure, Master data, Integraqtion and Scenario build with which they gain the  knowledge on SAP TM and confidence to work in SAP TM projects including the Implementation.",
    "ssi_skill name": "SAP TM Transportation Management",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9963/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagadeesha ",
    program_type: "Regular",
  },
  {
    sno: "32",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Warehousing",
    landscape: "On Premise",
    course_code: "ATCI-LKM-SAP-LT-CR-0052 , ATCI-LTT-SAP-LT-BLC-0006",
    course_image: "img-15",
    course_name: "SAP Extended Warehouse Management (EWM) with S/4HANA",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of SAP Extended Warehouse Management </li>\r\n<li class='bullet-des-li'> ECC / S4HANA – EWM Integration Session</li> \r\n<li class='bullet-des-li'>Master Data and Configuration aspects of SAP EWM</li>  <li class='bullet-des-li'>EWM inbound process</li> \r\n<li class='bullet-des-li'> EWM outbound process</li> \r\n<li class='bullet-des-li'>EWM internal process</li> \r\n</ul>",
    description:
      "This course covers Overview of SAP Extended Warehouse Management ECC / S4HANA – EWM Integration Session Master Data and Configuration aspects of SAP EWM EWM inbound process EWM outbound process EWM internal process Overview of EWM advanced processes / functionalities, Fiori Apps of EWM",
    learning_path: "Logistics",
    course_level: "Intermediate",
    "pre-requisite": "Strong knowledge in SAP MM or SAP SD or SAP PP ",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "45",
    mode: "Blended / Instructor Led",
    learning_outcomes:
      "The praticipants would gain the required knowledge on SAP EWM and would be able to work in the support and implementation projects.",
    ssi_skill_id: "80004591",
    "ssi_skill name": "SAP EWM",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$4811/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagadeesha ",
    program_type: "Regular",
  },
  {
    sno: "33",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Procurement",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0059",
    course_image: "img-17",
    course_name: "SAP MM Comprehensive Learning",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Intercompany process with and without IDOCs</li>\r\n <li class='bullet-des-li'>Subcontracting- Operational and Assembly</li>\r\n<li class='bullet-des-li'>SAP Analytical reports from SAP MM point of view</li>\r\n<li class='bullet-des-li'>SAP Analytical reports from SAP MM point of view</li>\r\n<li class='bullet-des-li'> Yard Management</li>\r\n<li class='bullet-des-li'>Ariba Procurement & Invoicing</li></ul>",
    description:
      "MM Integration with SD/ PP/FI : \n1. Intercompany process with and without IDOCs\n2. Third Party Process\n3. MRP\n4. Subcontracting- Operational and Assembly\nSAP S4 HANA : \n1. Flexible workflows functionality\n2. SAP Analytical reports from SAP MM point of view\n3. Central Procurement\n4. LTMC Tool introduction and its usage  Any one of the master as a sample\nSAP MM-EWM : \n1. Org Structure\n2. Master Data\n3. Inbound Processing\n4. Outbound Processing\n5. Physical Inventory\n6. Yard Management\n7. Replenishment\nARIBA : \n1. Ariba Sourcing\n2. Ariba Supplier Management\n3. Ariba Procurement & Invoicing\n4. Ariba CIG",
    learning_path: "SAP Materials Management Learning Path ",
    course_level: "Advanced",
    "pre-requisite": "SAP MM, SRM knowldege",
    Career_levels: "8,9,10,11",
    duration: "100",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course, learners will be able to understand MM Integration with SD/ PP/FI : 1. Intercompany process with and without IDOCs, 2. Third Party Process, 3. MRP, 4. Subcontracting- Operational and Assembly",
    "ssi_skill name": "SAP MM Materials Management",
    ssi_skill2_id: "",
    "ssi_skill2 name": "SAP Extended Warehouse Management",
    ssi_skill3_id: "",
    "ssi_skill3 name": "SAP Ariba",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9933/rel-task/2997$10951.htmld",
    additional_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9933/rel-task/2997$10951.htmld",
    "lead/poc": "Dinesh",
    program_type: "Special",
  },
  {
    sno: "34",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Data",
    landscape: "",
    course_code: "",
    course_image: "img-9",
    course_name: "Data loading techniques with SAP BODS",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>conceptual and hands on knowledge of development and handling to end-to-end loading from Source and target. </li><li class='bullet-des-li'>Explain the concepts of SAP Interface tools(ALEIDOC,LSMW,LTMC,BAPI) </li><li class='bullet-des-li'>Data NONSAP to SAP using BAPI,LSMW,LTMC and IDOC</li></ul>",
    description:
      "This course will provide conceptual and hands on knowledge of development and handling to end-to-end loading from Source and target. This course will help participants to Explain the concepts of SAP Interface tools(ALEIDOC,LSMW,LTMC,BAPI) Develop end-to-end to extraction data NONSAP to SAP using BAPI,LSMW,LTMC and IDOC ",
    learning_path: "SAP DATA",
    course_level: "Intermediate",
    "pre-requisite": "SAP BODS Knowledge",
    Career_levels: "",
    duration: "36",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants to Explain the concepts of SAP Interface tools(ALEIDOC,LSMW,LTMC,BAPI) Develop end-to-end to extraction data NONSAP to SAP using BAPI,LSMW,LTMC and IDOC ",
    "ssi_skill name": "SAP BusinessObjects Data Services",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9266/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "35",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "on cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0037",
    course_image: "img-1",
    course_name: "SAP BTP Build Apps",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Build Apps Introduction</li>\r\n <li class='bullet-des-li'>Simple Apps  - Creating List</li>\r\n<li class='bullet-des-li'>Capture and Upload Image</li>\r\n<li class='bullet-des-li'>Barcode Scanner</li>\r\n<li class='bullet-des-li'>Consuming ODATA services using destination</li>\r\n<li class='bullet-des-li'>Consume CAP project and perform CRUD operations</li></ul>",
    description:
      "This course provides details on SAP Build Apps Introduction, Composer Pro, Hands-on exrcises for the Concepts - Creating UI,Themes,Navigation, Components, Variables, Binding, Simple Apps  - Creating List, Capture and Upload Image, Barcode Scanner, Consuming ODATA services using destination, Consume CAP project and perform CRUD operations, Custom code using JavaScript etc..",
    learning_path: "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Any SAP Development Skill  / Any Functional Skil",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of the work you can develop web based and mobile based applications using SAP Build Apps",
    ssi_skill_id: "80035284",
    "ssi_skill name": "SAP BTP Build Low-Code",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8976/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link:
      "https://learning.sap.com/learning-journeys/compose-and-automate-with-sap-build-the-no-code-way\nhttps://learning.sap.com/learning-journeys/extending-sap-s-4hana-with-sap-build-apps-and-key-user-extensibility",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "36",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "on cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0015",
    course_image: "img-2",
    course_name: "SAP BTP Build Process Automation",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to SAP Process Automation</li>\r\n <li class='bullet-des-li'>Tenant registration</li>\r\n<li class='bullet-des-li'>SAP Process Automation</li>\r\n<li class='bullet-des-li'>Sales order Approval</li>\r\n<li class='bullet-des-li'>Process Visibility and Busienss AI services overview</li></ul>",
    description:
      "This course provides an introduction to SAP Process Automation, Tenant registration, Subscribe to SAP Process Automation from the trial account, Sales order Approval end to end process demo, integrate automation into a business process, Monitoring , Read Invoice documents demo, Process Visibility and Busienss AI services overview",
    learning_path: "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      "SAP ABAP Development / SAP UI5 Development/ Any RPA Skills Experience /Java Script",
    Career_levels: "7,8,9,10,11",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of the work you can create workflows and automations using Build Process Automation",
    ssi_skill_id: "80035283",
    "ssi_skill name": "SAP BTP Build Process Automation",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8976/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link:
      " https://learning.sap.com/learning-journeys/compose-and-automate-with-sap-build-the-no-code-way",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "37",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "on Cloud & on premise",
    course_code: "ATCI-LTT-SAP-LT-PRG-0002",
    course_image: "img-3",
    course_name: "SAP Full Stack Development",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Back-end (SAP ABAP, ABAP on HANA, NetWeaver Gateway OData services)</li>\r\n <li class='bullet-des-li'>Integration (Process/Data Integration) technologies</li>\r\n<li class='bullet-des-li'>Front-end (SAP UI5, SAP FIORI)</li>\r\n<li class='bullet-des-li'>Database (HANA)</li></ul>",
    description:
      "Full Stack SAP Development Engineer is a skilled person who can work on Back-end (SAP ABAP, ABAP on HANA, NetWeaver Gateway OData services), Front-end (SAP UI5, SAP FIORI), Database (HANA), and Integration (Process/Data Integration) technologies. A Full Stack developer gathers user requirements, designs the overall architecture, and builds a complete application. This course gives exhaustive information to the participants to develop an end-to-end enterprise-ready application.",
    learning_path: "ABAP, UI5,Integration",
    course_level: "Advanced",
    "pre-requisite":
      "SAP ABAP Proxy Framework, SAP ABAP Development, SAP ABAP CRM, SAP ABAP Web Dynpro Development, SAP ABAP Object Oriented Development, SAP ABAP Development for HANA, SAP HCM On Premise ABAP, SAP ABAP BOPF, SAP UI5 Fiori Development (HTML5 & Java), SAP Fiori/UI5 & Responsive Design Architecture, SAP HANA Cloud Platform Application Integration, SAP HANA Cloud Integration, SAP HANA, SAP HANA SQL Scripts Development",
    Career_levels: "7,8,9,10,11",
    duration: "123",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to build  end-to-end enterprise-ready applications using ABAP on HANA, NetWeaver Gateway OData services, SAP UI5, SAP FIORI,HANA and CPI.",
    ssi_skill_id: "80011516",
    "ssi_skill name": "SAP ABAP Development for HANA",
    ssi_skill2_id: "80011389",
    "ssi_skill2 name": "SAP UI5 Development",
    ssi_skill3_id: "80011681",
    "ssi_skill3 name": "SAP BTP Integration Suite",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/23455$997/rel-task/2998$35805.htmld",
    additional_url:
      "https://deepknowledge.accenture.com/course/view.php?id=451",
    "lead/poc": "Rama",
    program_type: "Special",
  },
  {
    sno: "38",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Arch",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-PRG-0001",
    course_image: "img-16",
    course_name: "SAP Full Stack Tech Arch",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>System build (Technical Architecture, Deployment, Installation, Migration)</li>\r\n <li class='bullet-des-li'>Administration & Operations and Security scenarios on SAP HANA</li>\r\n<li class='bullet-des-li'>SAP S/4HANA and SAP Fiori</li></ul>",
    description:
      "Full Stack SAP HANA Tech Arch is a System Administrator who can work on System build (Technical Architecture, Deployment, Installation, Migration), Administration & Operations and Security scenarios on SAP HANA, SAP S/4HANA and SAP Fiori. This course provides insights on all these skills and gives exhaustive hands-on exposure to the participants to Plan, Build, Deploy, Operate & Maintain an end-to-end SAP system landscape.",
    learning_path:
      "SAP S/4HANA Migration Learning Path,\nSAP S/4HANA Administration Learning Path,SAP HANA Database Administration Learning Path",
    course_level: "Advanced",
    "pre-requisite": "Knowledge on SAP BASIS Administration",
    Career_levels: "7,8,9,10,11",
    duration: "108",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course, you will be able to work on System build (Technical Architecture, Deployment, Installation, Migration), Administration & Operations and Security scenarios on SAP HANA, SAP S/4HANA and SAP Fiori.",
    "ssi_skill name": "SAP HANA DB Administration",
    ssi_skill2_id: "",
    "ssi_skill2 name": "SAP BASIS Administration",
    ssi_skill3_id: "",
    "ssi_skill3 name": "SAP SLO Upgrades & Migrations",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/23455$987/rel-task/2998$35805.htmld",
    additional_url:
      "https://deepknowledge.accenture.com/course/view.php?id=458",
    "lead/poc": "Jagan",
    program_type: "Special",
  },
  {
    sno: "39",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Arch",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0061",
    course_image: "img-8",
    course_name: "SAP BTP Administration & Security (1)",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Cloud Stratgey</li>\r\n <li class='bullet-des-li'>Overview of Intelligent Sustainable Enterprise</li>\r\n<li class='bullet-des-li'>Account Model and Services</li>\r\n<li class='bullet-des-li'>Kyma Runtime Environments</li>\r\n<li class='bullet-des-li'>SAP BTP Development &Admin Tools</li>\r\n<li class='bullet-des-li'>BTP Authorization concepts</li></ul>",
    description:
      "This course helps you to understand the below topics Setup SAP BTP Trial Account,SAP Cloud Stratgey,Overview of Intelligent Sustainable Enterprise,SAP BTP Architectures,Account Model and Services,ABAP, Cloud Foundry, and Kyma Runtime Environments, SAP BTP Development &Admin Tools,SAP BTP Configuration,SAP Discovery Center and BTP Boosters,SAP BTP CLI,Destinations,Cloud Connector,SAP BTP User Managemet, Role-Collectio, BTP Authorization concepts,SAP Cloud Identity Services,SAP BTP Database Offerings,SAP HANA Cloud Adinistration & Security,SAP BTP - Monitoring,SAP Application Logging Service,SAP Cloud ALM,SAP Cloud Transport Managemen etc,",
    learning_path: "BTP Learning Path,SAP Infra & Monitoring Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "SAP Basis & Security Knowledge required",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "27",
    mode: "Virtual",
    learning_outcomes:
      "This course provides participants with an overview of administrative tasks in the SAP Business Technology Platform (BTP). It covers the concepts of RISE with SAP and intelligent enterprise followed by the architecture of the SAP BTP. The architecture of global accounts, subaccounts, services, runtime environments is shown like Cloud Foundry, Kyma (Kubernetes), and ABAP. The tools SAP BTP Cockpit, SAP Discovery Center, and the command line interface (CLI) are used in exercises. Participants will learn how to define destinations, connect Cloud Connectors, create and assign role collections with pre-defined roles, understand SAP HANA Cloud and third-party databases. The application lifecycle management (ALM) compares the features of SAP Solution Manager, SAP Focused Run, and SAP Cloud ALM including monitoring in SAP BTP Cockpit. In addition, the SAP Cloud Transport Management Service (cTMS) is introduced.",
    "ssi_skill name": "SAP BTP Administration",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9943/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Jagan",
    program_type: "Regular",
  },
  {
    sno: "40",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-15",
    course_name: "SAP BTP Application Development",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of SAP BTP </li>\r\n <li class='bullet-des-li'>Extensibility Overview</li>\r\n<li class='bullet-des-li'>SAP Cloud Application Programming</li>\r\n<li class='bullet-des-li'>SAP HANA Cloud and SDI</li>\r\n<li class='bullet-des-li'>Developing UI5 apps using SAP BAS</li></ul>",
    description:
      "This course provides details on SAP and BTP Overview, Extensibility Overview, SAP Cloud Application Programming, SAP HANA Cloud and SDI, Developing UI5 apps using SAP BAS, SAP Build, SAP BTP AI Services and additional SAP BTP services overview",
    learning_path: "BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      "JavaScript/Node.js/Advance Front End Development Node.js/SAP UI5 Development/Java Full Stack Development /SAP ABAP Development/SAP BTP Extension Suite",
    Career_levels: "",
    duration: "70",
    mode: "Blended",
    learning_outcomes:
      "This course covers - BTP Overview, Admin Overview, Extensibility Overview, BTP DevOps Overview, SAP BTP AI Business Services, SAP LCNC Overview, Developing SAPUI5 applications using SAP Business Application Studio, SAP BTP Mobile Services Overview, SAP Build Work Overview, Task Center, SAP Cloud Application Programming Model, SAP HANA Cloud & SDI Overview and SAP Event Mesh & Advanced Event Mesh Overview.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP BTP Application Development",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9014/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "41",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Integration",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0034",
    course_image: "img-11",
    course_name: "SAP BTP Integration",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Technology Architecture Schoollet-des-ul'><li class='bullet-des-li'>SAP BTP and SAP Integration Suite</li>\r\n <li class='bullet-des-li'>SAP Cloud Integration</li>\r\n<li class='bullet-des-li'>SAP API Management</li>\r\n<li class='bullet-des-li'>SAP Ariba Cloud Integration Gateway</li>\r\n<li class='bullet-des-li'>SAP Trading Partner Management and SAP Edge Integration Cell</li></ul>",
    description:
      "This course provides details on SAP BTP and SAP Integration Suite. The course includes topics like SAP Cloud Integration, SAP API Management, SAP Open Connectors, SAP Integration Advisor, SAP Event Mesh, SAP Advanced Event Mesh, SAP Cloud Integration for data services, SAP Ariba Cloud Integration Gateway, SAP Graph, SAP Trading Partner Management and SAP Edge Integration Cell. It contains detailed information on various Integration topics and hands-on exercises.",
    learning_path: "BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      "SAP PO/PI & APIs Development/ SAP ABAP Development/ SAP UI5 Development/ SAP SuccessFactors Integrations Technical/SAP BTP Integration Suite/Any integration background",
    Career_levels: "4,5,6,7,8,9,10,11,12",
    duration: "90",
    mode: "Blended",
    learning_outcomes:
      "This course helps you to learn different Integration areas - SAP Integration, Open Connectors, API Management, Event Mesh & Advanced Event Mesh Overview, Overview of CPI-DS, CIG, and Integration Advisor.",
    ssi_skill_id: "80011681",
    "ssi_skill name": "SAP BTP Integration Suite",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9444/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link:
      "https://learning.sap.com/learning-journeys/modernizing-integration-with-sap-integration-suite",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "42",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "on cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0035",
    course_image: "img-12",
    course_name: "SAP BTP Application Development Architect",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>BTP and services overview</li>\r\n <li class='bullet-des-li'>SAP Enterprise Digital Core Interoperatability</li>\r\n<li class='bullet-des-li'>Extension with BTP Overview</li>\r\n<li class='bullet-des-li'>Decision Tree</li>\r\n<li class='bullet-des-li'>Reference Architecture</li>\r\n<li class='bullet-des-li'>Composable architecture</li></ul>",
    description:
      "This course contains details on BTP and services overview, SAP Enterprise Digital Core Interoperatability, Extension with BTP Overview,  Decision Tree, Reference Architecture, Composable architecture, BTP Use Cases, Customer stories",
    learning_path: "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite": "Work experience in any  BTP areas",
    Career_levels: "8,9",
    duration: "14",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course, you will gain knowledge on BTP application Development Architecure methodologies",
    ssi_skill_id: "80035269",
    "ssi_skill name": "SAP BTP Extension Suite",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9434/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "43",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Integration",
    landscape: "NA",
    course_code: "ATCI-LTT-SAP-LT-BLC-0050",
    course_image: "img-20",
    course_name: "SAP BTP Integration Architect",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of Integration Architecture</li>\r\n <li class='bullet-des-li'>Integration Patterns and Methodology</li>\r\n<li class='bullet-des-li'>Integration Technology mapping</li>\r\n<li class='bullet-des-li'>Role of Integration Architect and Key considerations</li></ul>",
    description:
      "This course contains overview of Integration Architecture, Integration Patterns and Methodology,  Integration Technology mapping, Decision Trees, Role of Integration Architect and Key considerations.",
    learning_path: "SAP BTP Learning Path",
    course_level: "Intermediate",
    "pre-requisite":
      "SAP PO/PI & APIs Development/SAP SuccessFactors Integrations Technical/SAP BTP Integration Suite/Any integration background/work experience in any  BTP areas",
    Career_levels: "4,5,6,7",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to work Integration methodologies",
    ssi_skill_id: "80011681",
    "ssi_skill name": "SAP BTP Integration Suite",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9633/rel-task/2997$10951.htmld",
    additional_url: "",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "44",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Procurement",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLC-0066",
    course_image: "img-19",
    course_name: "SAP Fieldglass",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Fieldglass</li>\r\n <li class='bullet-des-li'>SAP Fieldglass statement of work (SOW) Module</li>\r\n<li class='bullet-des-li'>Help businesses find, engage, and manage contractors, freelancers, temps, and outsourced services</li>\r\n<li class='bullet-des-li'>Contingent workforce management</li>\r\n<li class='bullet-des-li'>Services procurement</li>\r\n<li class='bullet-des-li'></li>\r\n<li class='bullet-des-li'>Assignment management</li>\r\n<li class='bullet-des-li'>Worker profile management</li></ul>",
    description:
      "This course covers SAP Fieldglass is a cloud-based software that helps businesses manage their external workforce and services procurement. It can help businesses find, engage, and manage contractors, freelancers, temps, and outsourced services. Contingent workforce management: Manage nonpayroll workers, such as contractors and freelancers, in one place, Services procurement: Track projects with external service providers, Assignment management: Onboard external workers, assign them to jobs, and create service entry sheets, Worker profile management: Manage worker information, Benefits of SAP Fieldglass, Improve worker productivity, Mitigate risks, Increase savings, Ramp up productivity, Meet demand, Streamline processes, Enhance security, SAP Fieldglass can help businesses manage their external workforce more agilely and resiliently, It can also help businesses gain greater insight, control, and savings",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "SAP MM, SRM knowldege",
    Career_levels: "",
    duration: "12",
    mode: "Instructor Led",
    learning_outcomes:
      "This course helps you to understand the below topics on High-Level\n- SAP Fieldglass Contingent Worker Module \n- SAP Fieldglass statement of work (SOW) Module \n- SAP Fieldglass Profile Workers Module \n- SAP Fieldglass Admin Configuration Module \n- SAP Fieldglass Analytics (Reporting) Module \n",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Fieldglass Contingent Workforce",
    mylearning_url: "",
    additional_url: "NA",
    "lead/poc": "Dinesh",
    program_type: "Regular",
  },
  {
    sno: "45",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Data",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-DG-0122",
    course_image: "img-2",
    course_name: "Syniti ADMM",
    bulleted_description:
      "\r\n<ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of the Migration of Syniti ADMM</li>\r\n <li class='bullet-des-li'>Set up, Design and ETL of ADMM</li>\r\n<li class='bullet-des-li'>Overview of all Syniti environment</li>\r\n<li class='bullet-des-li'>Data Migration and Management tool</li></ul>",
    description:
      "Syniti Advance Data Migration and Management tool, Syniti ADMM for short, is a cloud-based solution designed to streamline and optimize data migration processes for organizations. It leverages machine learning and automation to manage complex data migrations efficiently while maintaining high data quality. \nThis learning module is designed to provide an overview of the Migration of Syniti ADMM. The learning modules will provide an understanding  of the Set up, Design and ETL of ADMM. The videos provide a walkthrough of all in a Syniti environment",
    learning_path: "SAP DATA",
    course_level: "Intermediate",
    "pre-requisite": "SAP data, BODS knowledge",
    Career_levels: "6,7,8,9,10,11,12",
    duration: "45",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course, participants will have conceptual knowledge of how to set-up, Syniti ADMM, design and perform ETL activities on ADMM",
    "ssi_skill name": "Syniti ADM for SAP",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17816$19953/rel-task/2998$29489.htmld",
    additional_url: "",
    "lead/poc": "Dhiren",
    program_type: "Regular",
  },
  {
    sno: "46",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0001",
    course_image: "img-11",
    course_name: "SAP BTP Business AI",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to AI,ML and Generative AI, Pormpt Engineering , Python Overview, SAP AI Core and SAP Launch Pad, Generative AI  at SAP, Navigating LLM Fundamentals, GenAI Hub and SAP Ventor Engine</li><li class='bullet-des-li'> Navigating Large Language Models Fundamentals, Promt LLMs in the Generative AI Hub in SAP AI core & Launchpad, Implementing Retrieval Augumented Generation using HANA Vevtor Search.</li>",
    description:
      "This course provides details on Introduction to AI,ML and Generative AI, Pormpt Engineering , Python Overview, SAP AI Core and SAP Launch Pad, Generative AI  at SAP, Navigating LLM Fundamentals, GenAI Hub and SAP Ventor Engine, Navigating Large Language Models Fundamentals, Promt LLMs in the Generative AI Hub in SAP AI core & Launchpad, Implementing Retrieval Augumented Generation using HANA Vevtor Search.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "SAP Generative AI, Python, Any SAP Programming Language",
    Career_levels: "4,5,6,7,8,9,10,11",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to work on  SAP AI Core and SAP Launch Pad, Generative AI  at SAP,  GenAI Hub and SAP Vector Engine,  Prompt LLMs in the Generative AI Hub in SAP AI core & Launchpad, Orchestration, Implementing Retrieval Augmented Generation using HANA Vector Search.",
    ssi_skill_id: "80053806",
    "ssi_skill name": "SAP Generative AI",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$4781/rel-task/2997$10951.htmld",
    additional_url:
      "https://deepknowledge.accenture.com/course/view.php?id=2047",
    "lead/poc": "Rama",
    program_type: "Regular",
  },
  {
    sno: "47",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Analytics",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0030",
    course_image: "img-2",
    course_name: "SAP BW on HANA Data Modeling and Development",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Describe the present challenges in Data Warehousing and reporting</li><li class='bullet-des-li'>Explain the scope of HANA</li><li class='bullet-des-li'>Describe the new features of BW 7.3</li><li class='bullet-des-li'>Describe the present LSA architecture and its flaws</li><li class='bullet-des-li'>Explain the need for and advantages of LSA++ with HANA</li>",
    description:
      " This course covers Introduction to SAP HANA, Migrating to SAP BW Powered by an SAP HANA Database, “In-memory optimized” Data Store Objects and Info Cubes, Consuming HANA Models in BW and Vice-versa, Layered Scalable Architecture without SAP HANA, Layered Scalable Architecture plus plus (LSA++) with SAP HANA. Below concepts are covered:Describe the present challenges in Data Warehousing and reporting Explain the scope of HANA Describe the new features of BW 7.3 Describe the present LSA architecture and its flaws Explain the need for and advantages of LSA++ with HANA Give a high-level description of the BW on HANA migration process Explain the in-memory optimization process Describe when to optimize Info Providers List the advantages of optimization Migrate Standard Info Cubes to In-memory Optimized Info Cubes Migrate Standard DSOs to In-memory Optimized DSOs Rebuild Multi-Provider metadata",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "2 - 3 years experience on  SAP BI ",
    Career_levels: "CL4 to CL12",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to gain expertise in BW on HANA and be to able to efficiently use the BW on HANA knowledge on projects",
    ssi_skill_id: "80009562",
    "ssi_skill name": "SAP BW on HANA Data Modeling & Development",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8888/rel-task/2997$10951.htmld",
    additional_url: "",
    remarks: "Workday CC-NEW",
    "lead/poc": "Varadharajan",
    program_type: "Regular",
  },
  {
    sno: "48",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Analytics",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0064",
    course_image: "img-4",
    course_name: "SAP Business Objects 4.3 Data Reporting & Analytics",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to SAP BusinessObjects 4.3 is the latest iteration of the SAP BusinessObjects BI suite, offering a streamlined, modern user experience and enhanced analytics capabilities</li><li class='bullet-des-li'>Featuring a Fiori-based BI Launchpad, it simplifies navigation and access to tools like Web Intelligence and Crystal Reports.</li>",
    description:
      "This course covers Introduction to SAP BusinessObjects 4.3 is the latest iteration of the SAP BusinessObjects BI suite, offering a streamlined, modern user experience and enhanced analytics capabilities. Featuring a Fiori-based BI Launchpad, it simplifies navigation and access to tools like Web Intelligence and Crystal Reports. The release emphasizes hybrid deployment, integrating seamlessly with SAP Analytics Cloud for advanced analytics. Key enhancements include improved Web Intelligence capabilities, support for live data connectivity, enhanced data visualizations, and expanded collaboration tools. Robust security and governance ensure data integrity, while a responsive, mobile-friendly design supports decision-making on the go. SAP BusinessObjects 4.3 empowers organizations to drive agile, data-driven insights across their enterprises.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "SAP BI fundamentals",
    Career_levels: "CL4 to CL12",
    duration: "27",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of this course, learner will be able to Design basic universe, Perform basic administrative functions using CMC, Monitor scheduled reports, Develop and schedule web intelligence reports and Use BI launch pad and set preferences",
    ssi_skill_id: "80000544",
    "ssi_skill name": "SAP BusinessObjects Business Intelligence",
    ssi_skill2_id: "80003987",
    "ssi_skill2 name": "SAP BusinessObjects Universe Designer",
    ssi_skill3_id: "80003988",
    "ssi_skill3 name":
      "SAP BusinessObjects Web Intelligence Report Development",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9973/rel-task/2997$10951.htmld",
    additional_url: "",
    remarks: "Workday CC-NEW",
    "lead/poc": "Varadharajan",
    program_type: "Regular",
  },
  {
    sno: "49",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Analytics",
    landscape: "On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0031",
    course_image: "img-7",
    course_name: "SAP BW4/HANA Data Modeling and Development",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to HANA and BW4/HANA – (Overview of Architecture, Different Paths to migration Approach for BW/HANA, Conversion Tools, In-Memory Evaluation of SAP BI, BW4/HANA and BW Powered by HANA Difference)etc.</li><li class='bullet-des-li'>BW4HANA Modeling in HANA Studio- ( Modeling BI using BWMT, Creation of Providers, Transformations, DTP, Source systems, Process chains, Creation of Bex. Query Reports- Designer properties,RKF,CKF,Formulas,Variables,selections,Structures,Global Filters, Transports. etc.</li>",
    description:
      "This course covers Introduction to HANA and BW4/HANA – (Overview of Architecture, Different Paths to migration Approach for BW/HANA, Conversion Tools, In-Memory Evaluation of SAP BI, BW4/HANA and BW Powered by HANA Difference)etc.BW4HANA Modeling in HANA Studio- ( Modeling BI using BWMT, Creation of Providers, Transformations, DTP, Source systems, Process chains, Creation of Bex. Query Reports- Designer properties,RKF,CKF,Formulas,Variables,selections,Structures,Global Filters, Transports. etc.Advance Features in BW4/HANA overview concepts- HAP, BW Workspace, Mixed scenarios, SDA, ODP Data sources",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite":
      "2 - 3 years experience on  SAP BI or relevant experience on BW on HANA",
    Career_levels: "CL4 to CL12",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to gain expertise in BW4/HANA and be to able to efficiently use the BW4/HANA knowledge on projects",
    ssi_skill_id: "80018932",
    "ssi_skill name": "SAP BW/4HANA Data Modeling & Development",
    ssi_skill2_id: "80011381",
    "ssi_skill2 name": "SAP BW/4HANA",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8991/rel-task/2997$10951.htmld",
    additional_url:
      "https://open.sap.com/courses/bw4h2/items/xX8yibCNpuNkqexyoGpRg\n https://help.sap.com/viewer/107a6e8a38b74ede94c833ca3b7b6f51/1.0.3/en-US\n SAP BW/4HANA in a Nutshell | openSAP",
    lsc_link:
      "https://learning.sap.com/learning-journeys/getting-started-building-an-on-premise-data-warehouse-using-sap-bw-4hana",
    remarks: "Workday CC-NEW",
    "lead/poc": "Varadharajan",
    program_type: "Regular",
  },
  {
    sno: "50",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Analytics",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0046",
    course_image: "img-6",
    course_name: "SAP Analytics Cloud(SAC)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to SAP Analytics Cloud and Data preparation,SAP Analytics Cloud SaaS platform architecture,Data connectivity,Basic Modelling in SAP Analytics,Visualizations and Stories,Other advanced features for analytics</li>",
    description:
      "This course covers Introduction to SAP Analytics Cloud and Data preparation,SAP Analytics Cloud SaaS platform architecture,Data connectivity,Basic Modelling in SAP Analytics,Visualizations and Stories,Other advanced features for analytics At the end of this training, participants will have an understanding of SAC and Positioning of SAC with Data Connection, Modeling, and core Functionality of  Business Intelligence, Planning and Predictive Analytics",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite":
      "Basic Knowledge on Analytics and Reporting Tools like BO and BI",
    Career_levels: "CL4 to CL11",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of this training, participants will have an understanding of SAC and Positioning of SAC with Data Connection, Modeling, and core Functionality of  Business Intelligence, Planning and Predictive Analytics",
    ssi_skill_id: "80018938",
    "ssi_skill name": "SAP Analytics Cloud Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9487/rel-task/2997$10951.htmld",
    additional_url:
      "https://open.sap.com/courses/cp6\n https://open.sap.com/courses/sac5\n https://open.sap.com/courses/sac2\n https://www.youtube.com/watch?v=wiXw7lcheuU&list=PLkzo92owKnVxm3TMoUliy5b5UO1G5GP50\n https://help.sap.com/viewer/00f68c2e08b941f081002fd3691d86a7/release/en-US/6ea0ee725a624eebbd0012a267e7b7f9.html",
    lsc_link:
      "https://learning.sap.com/learning-journeys/exploring-sap-analytics-cloud",
    remarks: "Workday CC-NEW",
    "lead/poc": "Varadharajan",
    program_type: "Regular",
  },
  {
    sno: "51",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Data",
    landscape: "On Cloud & On premise",
    course_code: "ATCI-LTT-SAP-LT-PRG-0003",
    course_image: "img-8",
    course_name: "SAP Full Stack Data Engineer",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Insights on all these skills and an exhaustive experiential learning with hands-on to the participants to aid in developing enterprise-ready application</li>",
    description:
      "This course provides insights on all these skills and an exhaustive experiential learning with hands-on to the participants to aid in developing enterprise-ready application. In addition to these skills, a high-level overview of the Data Migration tools like Data Migration Cockpit, Syniti ADM, LTMC, LSMW etc. will be an added advantage.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "",
    "pre-requisite":
      "Knowledge on Data Migration and Basic knowledge on Data provision techniques ",
    Career_levels: "CL7 to CL11",
    duration: "110",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course, you will be able to work on Data services (BODS, CPI-DS), Data Integration (SDI), and Data Governance (SAP MDG) to develop data-oriented applications.",
    ssi_skill_id: "80012821",
    "ssi_skill name": "SAP Master Data Migration",
    ssi_skill2_id: "80000543",
    "ssi_skill2 name": "SAP BusinessObjects Data Services",
    ssi_skill3_id: "80026325",
    "ssi_skill3 name": "SAP CPI for Data Services",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/23455$1290/rel-task/2998$35805.htmld",
    additional_url:
      "https://deepknowledge.accenture.com/course/view.php?id=459",
    lsc_link: "NA",
    remarks: "Workday CC-NEW",
    "lead/poc": "Varadharajan",
    program_type: "Special",
  },
  {
    sno: "52",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Analytics",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0032",
    course_image: "img-1",
    course_name: "Data Integration & Analytics with SAP Datasphere",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Module -1 Data Warehouse Cloud/ SAP Datasphere Introduction will give overview of the Architecture of Data Warehouse Cloud </li><li class='bullet-des-li'>Module -2 Data Warehouse Cloud / SAP Datasphere Modeling will give knowledge to participants on how modeling can be done in DWC.</li>",
    description:
      "This course covers SAP Datasphere, the next generation of SAP Data Warehouse Cloud, is a comprehensive data service that enables every data professional to deliver seamless and scalable access to mission-critical business data. SAP Data Warehouse Cloud : is a fully managed, highly-integrated, open, and scalable cloud-native data warehouse solution. This course SAP Data Warehouse Cloud / SAP Datasphere is divided in to Two Modules as below: Module -1 Data Warehouse Cloud/ SAP Datasphere Introduction will give overview of the Architecture of Data Warehouse Cloud . Module -2 Data Warehouse Cloud / SAP Datasphere Modeling will give knowledge to participants on how modeling can be done in DWC.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite":
      "Basic Knowledge on Analytics and Reporting Tools like BO and BI",
    Career_levels: "CL4 to CL11",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this training, participants will have an understanding of Introduction to SAP Datasphere & SAP Datasphere Modeling like What are Spaces?How to Create Spaces,Creating an Open SQL Schema in a Space,How to Monitor your Spaces,Connection Types,How to Create Remote Connections,What is Data Modeling?How to Start Modeling Your Data Using a Graphical View,What is the Business Catalog?,What is the Business Builder Layer?How to Create New Dimensions , New Analytical Data Sets, New Fact  Model .New Consumption Model and Perspectives in the Business Builder Layer,How to Combine Data from Different Source Systems,What is Entity-Relationship Modeling?,How to Create an New table, New Graphical View and Entity-Relationship Model  in Data Builder Layer,How to Create a SQL View?Data cataloging and semantic modeling features.",
    ssi_skill_id: "80025360",
    "ssi_skill name": "SAP BTP Data Warehouse Cloud",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9007/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link:
      "https://learning.sap.com/learning-journeys/explore-sap-datasphere\n https://learning.sap.com/courses/introduction-to-sap-datasphere",
    remarks: "Workday CC-NEW",
    "lead/poc": "Varadharajan",
    program_type: "Regular",
  },
  {
    sno: "53",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Technology",
    landscape: "On Cloud",
    course_code: "ATCI-LTT-SAP-LT-BLC-0016",
    course_image: "img-19",
    course_name: "SAP BTP for Leadership",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Module -1  SAP BTP Overview</li><li class='bullet-des-li'>Module -2  Executive POV</li><li class='bullet-des-li'>Module -3  Rise with SAP & Soar with Accenture</li><li class='bullet-des-li'>Module -4  BTP Accelerators</li><li class='bullet-des-li'>Module -5  BTP Pricing Model</li><li class='bullet-des-li'>Module -6  SAP BTP use cases</li>",
    description:
      "This course covers SAP Business Technology Platform (SAP BTP) carries together intelligent enterprise applications with database and data management, analytics, integration, and extension capabilities into one platform for both cloud and hybrid environments. This course SAP Business Technology Platform(BTP) for Leaders is divided into Six Modules as below:Module -1  SAP BTP Overview. Module -2  Executive POV. Module -3  Rise with SAP & Soar with Accenture. Module -4  BTP Accelerators.Module -5  BTP Pricing Model.Module -6  SAP BTP use cases.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Any SAP consultant  Level – SM & above",
    Career_levels: "CL6 and Above",
    duration: "12",
    mode: "Blended",
    learning_outcomes:
      "This course gives an overview of - SAP BTP, BTP Services, Pricing model, BTP use cases, BTP Accelerators, and Rise with SAP.",
    ssi_skill_id: "80025384",
    "ssi_skill name": "SAP HANA Cloud",
    ssi_skill2_id: "80025360",
    "ssi_skill2 name": "SAP BTP Data Warehouse Cloud",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8829/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "NA",
    remarks: "Workday CC-NEW",
    "lead/poc": "Varadharajan",
    program_type: "Special",
  },
  {
    sno: "54",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Data",
    landscape: "On Cloud & On Premise",
    course_code: "ATCI-LTT-SAP-LT-BLC-0029",
    course_image: "img-9",
    course_name: "SAP BTP Data Framework for Architects",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>overview of SAP BTP, the TIDIP Framework, SAP Data use cases, SAP Data conversation starters, integration of SAP Data with AWS, and guidelines for estimation, ensuring a solid foundation for effective client engagement and data-driven strategies</li>",
    description:
      "This course covers how to enhance your data skills, empowering you to engage in meaningful discussions around SAP and deliver comprehensive, 360-degree value to clients. The course covers an overview of SAP BTP, the TIDIP Framework, SAP Data use cases, SAP Data conversation starters, integration of SAP Data with AWS, and guidelines for estimation, ensuring a solid foundation for effective client engagement and data-driven strategies.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": " Knowledge of SAP Data Areas ",
    Career_levels: "CL7 to CL8",
    duration: "14",
    mode: "Blended",
    learning_outcomes:
      "At the end of this training, participants will be able to enhance their Data skills, enable you to engage in impactful conversations around SAP, and deliver 360-degree value to our clients. This course covers BTP Overview, TIDIP Framework, SAP Data Use cases, SAP Data conversation Starters, SAP Data integration to AWS, Estimation Guidelines.",
    ssi_skill_id: "80025360",
    "ssi_skill name": "SAP BTP Data Warehouse Cloud",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9037/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "NA",
    remarks: "Workday CC-NEW",
    "lead/poc": "Varadharajan",
    program_type: "Special",
  },
  {
    sno: "55",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Analytics",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP BTP Analytics Framework for Architects",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>BTP Overview</li><li class=bullet-des-li'>TIDIP Framework</li><li class=bullet-des-li'>SAP Analytics ++ Use cases</li><li class=bullet-des-li'>SAP Analytics ++ Conversation Starters</li><li class=bullet-des-li'>SAP + Microsoft + Google – Insights Decision Trees and Reference Architecture and Estimation Guidelines.</li>",
    description:
      "This course covers how to enhance your analytical skills, enable you to engage in impactful conversations around SAP, and deliver 360-degree value to our clients. This course covers BTP Overview, TIDIP Framework, SAP Analytics ++ Use cases, SAP Analytics ++ Conversation Starters, SAP + Microsoft + Google – Insights Decision Trees and Reference Architecture and Estimation Guidelines.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge on Analytics and cloud",
    Career_levels: "",
    duration: "14",
    mode: "Blended",
    learning_outcomes:
      "At the end of this training, participants will be able to enhance their analytical skills, enable you to engage in impactful conversations around SAP, and deliver 360-degree value to our clients. This course covers BTP Overview, TIDIP Framework, SAP Analytics ++ Use cases, SAP Analytics ++ Conversation Starters, SAP + Microsoft + Google – Insights Decision Trees and Reference Architecture and Estimation Guidelines.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP BW on HANA Data Modeling & Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8682/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "56",
    type: "Technology",
    platform: "SAP",
    domain: "SAP HR",
    specialization: "SAP HCM",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP HR ABAP",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>understand the Functional /Technical Aspects for SAP HR like SAP HCM Business Processes</li><li class=bullet-des-li'>HR Infotypes,HR Tables,HR Time Constraints,ABAP Workbench Fundamentals</li><li class=bullet-des-li'>RICEF Overview,Creating Custom Tables & Custom Info types,HR-ABAP Programming using  HR Macros</li><li class=bullet-des-li'>Overview of HR Logical Databases, HR-ABAP Programming -  using Logical databases like PNPCE/PCH/PAP & ALV Report</li><li class=bullet-des-li'>HR-ABAP Reporting - Function Modules,Payroll Cluster Reporting,SAP HR Standard Reports ,SAP HR Reporting Tools like Ad hoc Query , SAP Query , SQVI etc.,</li>",
    description:
      "This course helps you to understand the Functional /Technical Aspects for SAP HR like SAP HCM Business Processes,HR Infotypes,HR Tables,HR Time Constraints,ABAP Workbench Fundamentals,RICEF Overview,Creating Custom Tables & Custom Info types,HR-ABAP Programming using  HR Macros,Overview of HR Logical Databases, HR-ABAP Programming -  using Logical databases like PNPCE/PCH/PAP & ALV Report,HR-ABAP Reporting - Function Modules,Payroll Cluster Reporting,SAP HR Standard Reports ,SAP HR Reporting Tools like Ad hoc Query , SAP Query , SQVI etc.,",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge on SAP ABAP programming Language",
    Career_levels: "",
    duration: "45",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to understand the various processes in SAP HR module, HR Macros , HR Logical Databases, ABAP Programs - ALV reports for HR related tables.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP HCM On Premise ABAP",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8850/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "57",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Security",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP GRC ACCESS CONTROL",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>understand the SAP GRC  Introduction,SAP GRC 12.0 - Access Control Overview</li><li class=bullet-des-li'>Access Risk Analysis (ARA),Access Request Management (ARM),Emergency Access Management (EAM)</li><li class=bullet-des-li'>Business Role Management (BRM),MSMP Workflow Configuration,Business Rule Framework and Standard Reporting etc.</li><li class=bullet-des-li'>helps the consultant to understand the basic configuration settings , Activating BC Sets , Technical Settings, Extraction of Reports using standard Reports delivered by SAP for each of the components of SAP GRC-AC etc.</li>",
    description:
      "This course helps you to understand the SAP GRC  Introduction,SAP GRC 12.0 - Access Control Overview, Access Risk Analysis (ARA),Access Request Management (ARM),Emergency Access Management (EAM),Business Role Management (BRM),MSMP Workflow Configuration,Business Rule Framework and Standard Reporting etc.. It also helps the consultant to understand the basic configuration settings , Activating BC Sets , Technical Settings, Extraction of Reports using standard Reports delivered by SAP for each of the components of SAP GRC-AC etc.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge of SAP Authorization concepts",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to understand the various processes in SAP HR module, HR Macros , HR Logical Databases, ABAP Programs - ALV reports for HR related tables.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Governance Risk & Compliance GRC",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8838/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "58",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP FSCM (Financial Supply Chain Management)",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP S/4HANA FSCM Treasury and Risk management",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Treasury overview</li><li class=bullet-des-li'>Money markets</li><li class=bullet-des-li'>Foreign exchange</li><li class=bullet-des-li'>Securities management</li><li class=bullet-des-li'>Cash management overview</li><li class=bullet-des-li'>In house cash overview</li>",
    description:
      "This course covers Treasury overview Money markets ,Foreign exchange, Securities management, Cash management overview, In house cash overview",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "Basic knowledge of SAP overview, SAP FICO & SAP SCM",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to,Understand SAP FSCM Treasury & Risk Management overview. Understand Transaction manager money market overview, money market products, money market transaction type, flow types and deal creations. Understand the securities market overview, product types, trader creation, securities transaction types and deal creation.Understand the Forex overview, product types, trader creation, Forex transaction types in and deal creation.Understand the cash management overview, process, configuration, In house cash management overview, process and configuration.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP FSCM Treasury & Risk Management TRM",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9903/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "59",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP FSCM (Financial Supply Chain Management)",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP S/4HANA FSCM Cash & Liquidity management",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Sap Cash Management Over view</li><li class=bullet-des-li'>Cash Management Functions and related SAP functionalities</li><li class=bullet-des-li'>Difference between ECC, S4HANA Basic and S4HANA Advanced Cash Management</li><li class=bullet-des-li'>Configuration Overview</li><li class=bullet-des-li'>Basics of Bank Account Management in S/4 HANA</li><li class=bullet-des-li'>Fiori Applications</li><li class=bullet-des-li'>Master Data Set Up required for Cash Management</li><li class=bullet-des-li'>A day in a life of Cash Manager: Process Flow</li><li class=bullet-des-li'>Process Discipline and Controls in SAP Cash Management</li><li class=bullet-des-li'>Other Aspects- Cash Management in Conversion and CFIN</li><li class=bullet-des-li'>Over View of Bank Management</li><li class=bullet-des-li'>Difference blw BAM Lite vs BAM full version</li><li class=bullet-des-li'>Basics of Bank Key ,House Bank,House Bank Accounts</li><li class=bullet-des-li'>New Features in Bank Account Management</li><li class=bullet-des-li'>Work flow in Bank Account Management</li><li class=bullet-des-li'>Overview of BCM</li><li class=bullet-des-li'>Features and Benefits of BCM</li><li class=bullet-des-li'>Key Concepts</li><li class=bullet-des-li'>Process Overview </li><li class=bullet-des-li'>Payment approval process through BAM</li>",
    description:
      "This course covers Sap Cash Management Over view ,Cash Management Functions and related SAP functionalities, Difference between ECC, S4HANA Basic and S4HANA Advanced Cash Management, Configuration Overview, Basics of Bank Account Management in S/4 HANA, Fiori Applications, Master Data Set Up required for Cash Management, A day in a life of Cash Manager: Process Flow, Process Discipline and Controls in SAP Cash Management, Other Aspects- Cash Management in Conversion and CFIN, Over View of Bank Management, Difference blw BAM Lite vs BAM full version, Basics of Bank Key ,House Bank,House Bank Accounts, New Features in Bank Account Management, Work flow in Bank Account Management, Overview of BCM, Features and Benefits of BCM, Key Concepts, Process Overview, Payment approval process through BAM",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Work experience on FICO / S4 Hana Finance",
    Career_levels: "",
    duration: "5",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand SAP Cash Management Overview, Cash Management Functions and functionalities. Understand Difference between ECC, S4HANA Basic and S4HANA Advanced Cash Management. Understand Configuration Overview, Basics of Bank Account Management in S/4 HANA and Fiori Applications. Understand Master Data Set Up required for Cash Management. Understand Process Discipline and Controls in SAP Cash Management. Understand Other Aspects- Cash Management in Conversion and CFIN",
    ssi_skill_id: "",
    "ssi_skill name": "SAP S/4HANA Cash Management",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9893/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "60",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP Management Accounting",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP S/4Hana Management Accounting",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Controlling Overview & Basic Settings</li><li class=bullet-des-li'>Cost Center Accounting</li><li class=bullet-des-li'>Internal Orders Management</li><li class=bullet-des-li'>Product Costing</li><li class=bullet-des-li'>Material Ledger Accounting</li><li class=bullet-des-li'>Profit center accounting</li><li class=bullet-des-li'>Profitability Analysis</li>",
    description:
      "This course covers Controlling Overview & Basic Settings ,Cost Center Accounting, Internal Orders Management, Product Costing, Material Ledger Accounting, Profit center accounting, Profitability Analysis.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "SAP FI Knowledge",
    Career_levels: "",
    duration: "40",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand Controlling Overview & Basic Settings, Understand Cost Center Accounting, Understand Internal Orders Management, Understand Product Costing, Understand Material Ledger Accounting, Understand Profit center accounting, Understand Profitability Analysis",
    ssi_skill_id: "",
    "ssi_skill name": "SAP CO Management Accounting",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10032/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "61",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP Reporting",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP S/4HANA Group Reporting",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SAP S/4HANA Group Reporting Introduction & Overview</li><li class=bullet-des-li'>SAP S/4HANA Group Reporting Master Data Preparation</li><li class=bullet-des-li'>SAP S/4HANA Group Reporting Data Monitor</li><li class=bullet-des-li'>SAP S/4HANA Group Reporting Consolidations Monitor</li><li class=bullet-des-li'>SAP S/4HANA Group Reporting Option</li><li class=bullet-des-li'>SAP S/4HANA Group Reporting Data Monitor</li><li class=bullet-des-li'>SAP S/4HANA Group Reporting Consolidations Monitor</li><li class=bullet-des-li'>SAP S/4HANA Group Reporting Option</li>",
    description:
      "This course covers SAP S/4HANA Group Reporting Introduction & Overview , SAP S/4HANA Group Reporting Master Data Preparation, SAP S/4HANA Group Reporting Data Monitor, SAP S/4HANA Group Reporting Consolidations Monitor, SAP S/4HANA Group Reporting Option, SAP S/4HANA Group Reporting Data Monitor, SAP S/4HANA Group Reporting Consolidations Monitor, SAP S/4HANA Group Reporting Option.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "SAP FI Knowledge",
    Career_levels: "",
    duration: "45",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand SAP Group Reporting Introduction & Overview, Understand Master Data, Understand Data Preparation, Understand Intercompany Matching & Reconciliation (ICMR), Understand Data Monitor, Understand Consolidation , Understand Intercompany Eliminations, Understand Plan & Matrix Consolidation, Understand Group Reporting & Data Collection (GRDC), Understand Group Reporting",
    ssi_skill_id: "",
    "ssi_skill name": "SAP S/4HANA Group Reporting",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9910/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "62",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP FSCM (Financial Supply Chain Management)",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP S/4Hana FSCM In House Cash Management (IHCM)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>In - House cash Overview</li><li class=bullet-des-li'>Major Configuration</li><li class=bullet-des-li'>Master Data</li><li class=bullet-des-li'>Payment Process Overview</li>",
    description:
      "This Course Covers : In - House cash Overview, Major Configuration, Master Data, Payment Process Overview",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Advanced",
    "pre-requisite": "Work experience on FICO / S4 Hana Finance",
    Career_levels: "",
    duration: "6",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand In - House cash Overview, Understand Major Configuration, Understand Master Data, Understand Payment Process Overview",
    ssi_skill_id: "",
    "ssi_skill name": "SAP FSCM In-House Cash",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9893/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "63",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP FSCM (Financial Supply Chain Management)",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP FSCM Credit, Collections & Disputes Management",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Overview of Credit Management</li><li class=bullet-des-li'>Comparison between ECC and S4 Hana</li><li class=bullet-des-li'>License, Key Terms in Credit Management</li><li class=bullet-des-li'>Process Flow, Features of credit management, and configuration Objects</li>, <li class=bullet-des-li'>Overview of collection management, structure and Key Terms</li><li>Features of collection Management, Configuration Objects & System Demo</li><li>Overview of Dispute Management, Process and Phases</li><li>Roles in dispute Management, and Key Terms</li><li>Features of Dispute Management, Configuration Objects & System Demo</li></ul>",
    description:
      "This Course: Overview of Credit Management, Comparison between ECC and S4 Hana, License, Key Terms in Credit Management, Process Flow, Features of credit management, and configuration Objects, Overview of collection management, structure and Key Terms, Features of collection Management, Configuration Objects & System Demo, Overview of Dispute Management, Process and Phases, Roles in dispute Management, and Key Terms, Features of Dispute Management, Configuration Objects & System Demo",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "SAP FI Knowledge",
    Career_levels: "",
    duration: "6",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand Overview of Credit Management, Understand Comparison between ECC and S4 Hana, Understand License, Key Terms in Credit Management, Understand Process Flow, Features of credit management, and configuration Objects, Understand Overview of collection management, structure and Key Terms, Understand Features of collection Management, Configuration Objects & System Demo, Understand Overview of Dispute Management, Process and Phases, Understand Roles in dispute Management, and Key Terms, Understand Features of Dispute Management, Configuration Objects & System Demo",
    ssi_skill_id: "",
    "ssi_skill name": "SAP FSCM Credit Management",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9903/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "64",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Tech-Arch",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP Fiori System Administration(1)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Fiori Introduction</li><li class=bullet-des-li'>Exploring SAP Fiori Apps Library</li><li class=bullet-des-li'>SAP Fiori Deployments</li><li class=bullet-des-li'>SAP Fiori Configuration</li><li class=bullet-des-li'>SAP Fiori Launchpad</li><li class=bullet-des-li'>SAP Fiori Administration</li><li class=bullet-des-li'>SAP Fiori Security</li><li class=bullet-des-li'>SAP Fiori Troubleshooting</li>",
    description:
      "This course covers the below topics SAP Fiori Introduction, Exploring SAP Fiori Apps Library, SAP Fiori Deployments, SAP Fiori Configuration, SAP Fiori Launchpad,SAP Fiori Administration,SAP Fiori Security, SAP Fiori Troubleshooting etc.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Basic knowledge in SAP Basis",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to perfom fiori set up and perform fiori administration activities",
    ssi_skill_id: "",
    "ssi_skill name": "SAP BASIS Administration",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$13446/rel-task/2997$10951.html",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "65",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP Analytics",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP Anayltics Cloud Planning (FI)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to SAC and Basic of Modelling</li><li class=bullet-des-li'>Basics of Modelling (Dimension, Models) Modelling Concept</li><li class=bullet-des-li'>Data Sources, Integration & Management</li><li class=bullet-des-li'>Stories,Templates & Version Management</li><li class=bullet-des-li'>Data Manipulation (Data Actions, Formulas, Scripting)</li><li class=bullet-des-li'>Strategic Planning & Predictive Forecasting</li><li class=bullet-des-li'>Collaboration, Calendar, Data Locks, Security Management</li><li class=bullet-des-li'>Augmented Analytics and Digital Boardroom</li><li class=bullet-des-li'>Analytics Designer & Smart Predict</li><li class=bullet-des-li'>Planning Templates & Advance Features</li>",
    description:
      "This course covers Introduction to SAC and Basic of Modelling, Basics of Modelling (Dimension, Models) Modelling Concept, Data Sources, Integration & Management, Stories,Templates & Version Management, Data Manipulation (Data Actions, Formulas, Scripting), Strategic Planning & Predictive Forecasting, Collaboration, Calendar, Data Locks, Security Management, Augmented Analytics and Digital Boardroom, Analytics Designer & Smart Predict, Planning Templates & Advance Features etc.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Strong knowledge in Finance Domain",
    Career_levels: "",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understad Introduction to SAC and Basics of Modeling (Dimension, Models), Modeling Concept, Data Sources, Integration & Management,Stories, Templates & Version Management, Data Manipulation (Data Actions, Formulas, Scripting), Strategic Planning & Predictive Forecasting, Collaboration, Calendar, Data Locks, Security Management, Augmented Analytics and Digital Boardroom, Analytics Designer & Smart Predict, Planning Templates & Advance Features",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Analytics Cloud Planning",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$11831/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "66",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Finance",
    specialization: "SAP Finance",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP S/4HANA Public Cloud Finance",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SAP S/4HANA Public Cloud Intoduction and Landscape</li><li class=bullet-des-li'>FI Organizational Structure, & Finance Basic Settings</li><li class=bullet-des-li'>GL Master Data,Petty Cash and GL Transaction Postings</li><li class=bullet-des-li'>AP Configuration and Supplier Master Data</li><li class=bullet-des-li'>AP Transaction Postings</li><li class=bullet-des-li'>AR Configuration and Customer Master Data</li><li class=bullet-des-li'>AR Transaction Postings</li><li class=bullet-des-li'>Asset Master Data and Transactions</li><li class=bullet-des-li'>Cost Center and Profit Center</li><li class=bullet-des-li'>Bank Accounting</li>",
    description:
      "This course covers SAP S/4HANA Public Cloud Intoduction and Landscape, FI Organizational Structure, & Finance Basic Settings, GL Master Data,Petty Cash and GL Transaction Postings, AP Configuration and Supplier Master Data, AR Configuration and Customer Master Data, AR Transaction Postings, Asset Master Data and Transactions, Cost Center and Profit Center, Bank Accounting.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Strong knowledge in Finance Domain",
    Career_levels: "",
    duration: "25",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of this course, participants will be able to   understand S4HANA Public Cloud overview and System landscape , Private and Hybrid cloud overview. Understand Configure Your Business Solution Process  and its Configurations.Understand GL Cloud fiori customizing and user Apps.Understand AP Cloud Fiori period end and Transaction Porcess apps. Understand AR Cloud Fiori apps and Transaction Process. Bank master data apps. Understand Asset Cloud Fiori apps. Understand CO Cloud Fiori Apps",
    ssi_skill_id: "",
    "ssi_skill name": "SAP S/4HANA Cloud Public Finance",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10587/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "67",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP BTP Mobile Services Development",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>knowledge of SAP Mobile Services and SAP Mobile Cards</li><li class=bullet-des-li'>improve employee productivity, and enhance customer interactions</li><li class=bullet-des-li'>architecture and components of SAP Mobile Services</li><li class=bullet-des-li'>Build, deploy, and manage mobile applications using SAP Mobile Services</li><li class=bullet-des-li'>Implement real-time business data integration into SAP Mobile apps</li><li class=bullet-des-li'>Create mobile cards for various business scenarios</li><li class=bullet-des-li'>Learn the role of mobile services in modern enterprise systems and cloud environments.</li>",
    description:
      "This course is designed to provide in-depth knowledge of SAP Mobile Services and SAP Mobile Cards, which are key components of SAP's mobile enterprise solutions. These technologies empower businesses to deliver seamless mobile experiences, improve employee productivity, and enhance customer interactions by providing mobile access to business processes and real-time data. In this course you will learn the architecture and components of SAP Mobile Services. Build, deploy, and manage mobile applications using SAP Mobile Services. Explore the features and benefits of SAP Mobile Cards. Implement real-time business data integration into SAP Mobile apps.Create mobile cards for various business scenarios. Learn the role of mobile services in modern enterprise systems and cloud environments.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Basic Knowledge on UI5, Java Script",
    Career_levels: "",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course, you will gain knowledge on SAP Mobile Application development.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP BTP Mobile Application Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10846/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "68",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "N/A",
    course_image: "img-16",
    course_name: "SAP BTP Build Work Zone",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Work Zone and its usage</li><li class=bullet-des-li'>Participant will get an idea on creation of Home page in SAP Work Zone</li><li class=bullet-des-li'>One can get an idea the procedure to add Workplace, SAP UI5, URL and Web Dynpro ABAP to SAP Work Zone</li><li class=bullet-des-li'>covers different Build Work Zone Advanced edition features</li><li class=bullet-des-li'>creation of UI Integration Card using SAP BAS</li><li class=bullet-des-li'>integrating UI Integration card</li><li class=bullet-des-li'>Integrating SAP Build Process Automation URL and Task Center overview</li>",
    description:
      " This course provides overview  on SAP Work Zone and its usage. Participant will get an idea on creation of Home page in SAP Work Zone. One can get an idea the procedure to add Workplace, SAP UI5, URL and Web Dynpro ABAP to SAP Work Zone. It covers different Build Work Zone Advanced edition features - work space creation, creation of UI5,Web Dynpro, URL tile, creation of UI Integration Card using SAP BAS,integrating UI Integration card , Integrating SAP Build Process Automation URL and Task Center overview",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite":
      "Basic Knowledge on BTP Admin&Security and Fiori Launchpad Designer",
    Career_levels: "",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to work on SAP Build Work Zone and its capabilities.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP BTP Application Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10846/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "69",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP IBP Advanced - Supply Chain Control Tower",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0014",
    course_image: "img-16",
    course_name: "SAP IBP Advanced - Supply Chain Control Tower",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Supply Chain Control Tower training covers various aspects of end to end planning in IBP i.e.</li><li class=bullet-des-li'>Analytics & Dashboards</li><li class=bullet-des-li'>Customer Alerts</li><li class=bullet-des-li'>Process Management</li><li class=bullet-des-li'>Intelligent Visibility</li><li class=bullet-des-li'>Manage Analytics Stories</li>",
    description:
      "This course covers Supply Chain Control Tower training covers various aspects of end to end planning in IBP i.e. Analytics & Dashboards, Customer Alerts, Process Management, Intelligent Visibility, Manage Analytics Stories.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Understanding and experience of the IBP is rquired",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on  Supply Chain Control Tower training covers various aspects of end to end planning in IBP i.e. Analytics & Dashboards, Customer Alerts, Process Management, Intelligent Visibility, Manage Analytics Stories. At the end of the training, participants will have an understanding of the basic concepts of Control tower module and will have hands on experience on the Control Tower functionalities.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10405/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "70",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Global Trade Services Training",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLC-0005",
    course_image: "img-16",
    course_name: "SAP Global Trade Services Training",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to GTS</li><li class=bullet-des-li'>ECC- GTS integratio</li><li class=bullet-des-li'>Risk- Preference</li><li class=bullet-des-li'>Management Letter of credit/Restitution (Theory)</li><li class=bullet-des-li'>Customs-Export Customs-Import Compliance</li><li class=bullet-des-li'>SPL Compliance -Embargo</li><li class=bullet-des-li'>Legal Control Special Customs Procedures</li>><li class=bullet-des-li'>Transit (Theory) Electronic Compliance Reporting</li>",
    description:
      "This course covers Introduction to GTS, ECC- GTS integration, Risk- Preference, Management Letter of credit/Restitution (Theory), Customs-Export Customs-Import Compliance, SPL Compliance -Embargo, Legal Control Special Customs Procedures, Transit (Theory) Electronic Compliance Reporting",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": " SAP MM, SAP SD  , SAP TM",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will understand Introduction to GTS ECC- GTS integration Risk- Preference Management Letter of credit/Restitution (Theory) Customs-Export Customs-Import Compliance- SPL Compliance -Embargo, Legal Control Special Customs Procedures, Transit (Theory) Electronic Compliance Reporting",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Global Trade Services",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8442/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "71",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0074",
    course_image: "img-16",
    course_name: "IBP Advanced Training – Analytics",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Process management</li><li class=bullet-des-li'>Machine Learning Custom Alerts</li><li class=bullet-des-li'>Intelligent Visibility</li><li class=bullet-des-li'>Advanced Analytics and Dashboards and Manage Analytics Stories</li><li class=bullet-des-li'>help visualize the data for various business and gives the planners a platform to have all the charts in a single space</li><li class=bullet-des-li'>Training the team on these topics is helpful for the projects.</li>",
    description:
      "This course covers Advanced Training on Analytics will cover complex topics like Process management, Machine Learning Custom Alerts, Intelligent Visibility, Advanced Analytics and Dashboards and Manage Analytics Stories.These topics will help visualize the data for various business and gives the planners a platform to have all the charts in a single space. Training the team on these topics is helpful for the projects.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Understanding of IBP supply planning is required",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on  complex topics like Process management, Machine Learning Custom Alerts, Intelligent Visibility, Advanced Analytics and Dashboards and Manage Analytics Stories.These topics will help visualize the data for various business and gives the planners a platform to have all the charts in a single space.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10265/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "72",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0075",
    course_image: "img-16",
    course_name: "IBP Advanced Training – Finite Heuristics",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>TS Finite Heuristics will cover the calculation logic</li><li class=bullet-des-li'>comparison between different algorithms</li><li class=bullet-des-li'>functionalities valid/not valid for Finite Heuristics</li><li class=bullet-des-li'>Non Delivery & Late Delivery</li><li class=bullet-des-li'>Use Cases - Manual Adj & Leadtimes</li><li class=bullet-des-li'>Lot Sizes; Capacity & Prebuild</li><li class=bullet-des-li'>Quotas; Fair Share Distribution; Location Product Substitution</li><li class=bullet-des-li'>Demand Categorisation</li><li class=bullet-des-li'>Aggregated Constraints</li>",
    description:
      "This course covers TS Finite Heuristics will cover the calculation logic, comparison between different algorithms, functionalities valid/not valid for Finite Heuristics. It also covers the following topics in detail: Non Delivery & Late Delivery;Use Cases - Manual Adj & Leadtimes;Lot Sizes; Capacity & Prebuild;Quotas; Fair Share Distribution; Location Product Substitution;Demand Categorisation;Aggregated Constraints.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite":
      "Understanding of IBP supply planning is required. Should atleast have exposure to TS heuristics(3-6 months)",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on  TS Finite Heuristics will cover the calculation logic, comparison between different algorithms, functionalities valid/not valid for Finite Heuristics. It also covers the following topics in detail: Non Delivery & Late Delivery;Use Cases - Manual Adj & Leadtimes;Lot Sizes; Capacity & Prebuild;Quotas; Fair Share Distribution; Location Product Substitution;Demand Categorisation;Aggregated Constraints.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10120/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "73",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0076",
    course_image: "img-16",
    course_name: "IBP Advanced Training – Planning Model",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>TS Finite Heuristics will cover the calculation logic</li><li class=bullet-des-li'>comparison between different algorithms</li><li class=bullet-des-li'>functionalities valid/not valid for Finite Heuristics</li><li class=bullet-des-li'>Non Delivery & Late Delivery</li><li class=bullet-des-li'>Use Cases - Manual Adj & Leadtimes</li><li class=bullet-des-li'>Lot Sizes; Capacity & Prebuild</li><li class=bullet-des-li'>Quotas; Fair Share Distribution; Location Product Substitution</li><li class=bullet-des-li'>Demand Categorisation</li><li class=bullet-des-li'>Aggregated Constraints</li>",
    description:
      "This course covers TS Finite Heuristics will cover the calculation logic, comparison between different algorithms, functionalities valid/not valid for Finite Heuristics. It also covers the following topics in detail: Non Delivery & Late Delivery;Use Cases - Manual Adj & Leadtimes;Lot Sizes; Capacity & Prebuild;Quotas; Fair Share Distribution; Location Product Substitution;Demand Categorisation;Aggregated Constraints.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Understanding of IBP supply planning is required",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on Planning Model will cover complex topics - configurations and custom logics that help resolve specific business scenarios. Calculations that can be used at request level, at time profile attribute and time independent calculations would be covered.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10120/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "74",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0077",
    course_image: "img-16",
    course_name: "IBP Advanced Training – Inventory Optimization",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Inventory Optimization will cover complex topics</li><li class=bullet-des-li'>Inventory Optimization subprocess in IBP</li><li class=bullet-des-li'>explains the need for stock</li><li class=bullet-des-li'>functioning of the Multi-Echelon Inventory Optimization Operator</li><li class=bullet-des-li'>factors that impact Recommended Safety Stock and its breakup along with other components of Target Inventory Position</li>",
    description:
      "This course covers Inventory Optimization will cover complex topics. It covers the Inventory Optimization subprocess in IBP, explains the need for stock, functioning of the Multi-Echelon Inventory Optimization Operator, factors that impact Recommended Safety Stock and its breakup along with other components of Target Inventory Position.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Understanding of IBP supply planning is required",
    Career_levels: "",
    duration: "8",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on Inventory Optimization will cover complex topics. Inventory Optimization subprocess in IBP, explains the need for stock, functioning of the Multi-Echelon Inventory Optimization Operator, factors that impact Recommended Safety Stock and its breakup along with other components of Target Inventory Position.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10496/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "75",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0078",
    course_image: "img-16",
    course_name: "IBP Advanced Training - TS Optimizer",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>TS Optimizer covers the functional and technical overview of advanced functionalities supported by SAP-IBP Time Series Optimizer</li><li class=bullet-des-li'>System setup/Configuration steps along with system demo is covered for detailed instructions</li><li class=bullet-des-li'>It further highlights multitude of different business use cases where one can implement the respective functionalities in projects</li>",
    description:
      "This course covers TS Optimizer covers the functional and technical overview of advanced functionalities supported by SAP-IBP Time Series Optimizer. System setup/Configuration steps along with system demo is covered for detailed instructions. It further highlights multitude of different business use cases where one can implement the respective functionalities in projects.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Understanding of IBP supply planning is required",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on Advanced Training on TS Optimizer covers the functional and technical overview of advanced functionalities supported by SAP-IBP Time Series Optimizer. System setup/Configuration steps along with system demo is covered for detailed instructions. It further highlights multitude of different business use cases where one can implement the respective functionalities in projects.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10508/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "76",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0079",
    course_image: "img-16",
    course_name: "SAP IBP Control Tower",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>various aspects of end to end planning in IBP i.e. Analytics & Dashboards</li><li class=bullet-des-li'>Customer Alerts</li><li class=bullet-des-li'>Process Management</li><li class=bullet-des-li'>Intelligent Visibility, Manage Analytics Stories</li><li class=bullet-des-li'>participants will have an understanding of the basic concepts of Control tower module</li><li class=bullet-des-li'>have hands on experience on the Control Tower functionalities</li>",
    description:
      "This course covers various aspects of end to end planning in IBP i.e. Analytics & Dashboards, Customer Alerts, Process Management, Intelligent Visibility, Manage Analytics Stories. At the end of the training, participants will have an understanding of the basic concepts of Control tower module and will have hands on experience on the Control Tower functionalities.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Understanding of IBP supply planning is required",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on Advanced Training on TS Optimizer covers the functional and technical overview of advanced functionalities supported by SAP-IBP Time Series Optimizer. System setup/Configuration steps along with system demo is covered for detailed instructions. It further highlights multitude of different business use cases where one can implement the respective functionalities in projects.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10405/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "77",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0080",
    course_image: "img-16",
    course_name: "SAP IBP Order Based Planning (OBP) – Advanced ",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>various aspects of integration</li><li class=bullet-des-li'>the Optimizer supply planning runs</li><li class=bullet-des-li'>Location Product Substitution and TLB</li><li class=bullet-des-li'>participants will have an understanding of the advanced concepts of OBP</li><li class=bullet-des-li'>experience on the OBP Optimizer supply planning engine</li>",
    description:
      "This course covers various aspects of integration, the Optimizer supply planning runs, Location Product Substitution and TLB. At the end of the training, participants will have an understanding of the advanced concepts of OBP and will have hands on experience on the OBP Optimizer supply planning engine.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Understanding of IBP supply planning is required",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on the OBP Advanced aspects of integration, the Optimizer supply planning runs, Location Product Substitution and TLB and  advanced concepts of OBP and will have hands on experience on the OBP Optimizer supply planning engine.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10376/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "78",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0081",
    course_image: "img-16",
    course_name: "SAP IBP Order Based Planning (OBP) – Basics",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>various aspects of integration</li><li class=bullet-des-li'>master data/transaction data</li><li class=bullet-des-li'>profiles and the Heuristics supply planning run</li><li class=bullet-des-li'>understanding of the basic concepts of OBP</li><li class=bullet-des-li'>experience on the OBP Heuristics supply planning engine</li>",
    description:
      "This course covers various aspects of integration, master data/transaction data, profiles and the Heuristics supply planning run. At the end of the training, participants will have an understanding of the basic concepts of OBP and will have hands on experience on the OBP Heuristics supply planning engine.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Understanding of IBP supply planning is required",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants can work on the OBP Basic - aspects of integration, master data/transaction data, profiles and the Heuristics supply planning run. and  the basic concepts of OBP and will have hands on experience on the OBP Heuristics supply planning engine.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10557/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "79",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Production Planning and Detailed Scheduling (PPDS)",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0082",
    course_image: "img-16",
    course_name: "SAP Production Planning and Detailed Scheduling (PPDS)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Master Data</li><li class=bullet-des-li'>Transactional Data</li><li class=bullet-des-li'>Heurisitic & Optimizer Scenarios</li><li class=bullet-des-li'>Fiori Apps and Data Visualization</li><li class=bullet-des-li'>DS Scheduling Board</li><li class=bullet-des-li'>Pegging</li><li class=bullet-des-li'>Setup Matrix and Alerts</li>",
    description:
      "This course covers various aspects such as Master Data, Transactional Data, Heurisitic & Optimizer Scenarios, Fiori Apps and Data Visualization, DS Scheduling Board, Pegging, Setup Matrix and Alerts.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite":
      "Understanding of IBP supply planning is required. SAP PP knowledge would help",
    Career_levels: "",
    duration: "10",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this training, participants will be able to understand  and work on  Master Data, Transactional Data, Heurisitic & Optimizer Scenarios, Fiori Apps and Data Visualization, DS Scheduling Board, Pegging, Setup Matrix and Alerts.",
    ssi_skill_id: "",
    "ssi_skill name":
      "SAP S/4HANA Embedded Production Planning and Detailed Scheduling (EPPDS)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10475/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "80",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Integrated Business Planning",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0086",
    course_image: "img-16",
    course_name: "SAP Integrated Business Planning",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Integrated Business Planning (IBP)</li><li class=bullet-des-li'>focuses on the niche area of Demand, Supply, S&OP and Inventory optimization</li><li class=bullet-des-li'>advanced analytics features</li><li class=bullet-des-li'>real time reporting capability and several optimization algorithm</li><li class=bullet-des-li'>overview of following modules in this training</li><li class=bullet-des-li'>IBP for Sales and Operations Planning</li><li class=bullet-des-li'>IBP for Demand</li><li class=bullet-des-li'>SAP Supply Chain Control tower</li><li class=bullet-des-li'>SAP Cloud Platform integration Data Services (CPI-DS)</li><li class=bullet-des-li'>SAP Smart Data layer (SDI)</li>",
    description:
      "This course covers SAP – Integrated Business Planning (IBP) is the latest offering from SAP in the area of advanced supply chain planning and focuses on the niche area of Demand, Supply, S&OP and Inventory optimization. Built on top of SAP – HANA database, it offers advanced analytics features, real time reporting capability and several optimization algorithm. We will cover overview of following modules in this training, IBP for Sales and Operations Planning, IBP for Demand, IBP for Response and Supply, IBP for Inventory, SAP Supply Chain Control tower, SAP Cloud Platform integration Data Services (CPI-DS), SAP Smart Data layer (SDI)",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "Sound knowledge / experience on SAP PP or SAP SCM",
    Career_levels: "",
    duration: "40",
    mode: "Virtual",
    learning_outcomes:
      "At the end of this course, participants will understand the key business process and the benefits of SAP IBP.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Integrated Business Planning (IBP)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url: "https://wd10+L77+M77",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "81",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Procurement",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLV-0127",
    course_image: "img-16",
    course_name: "SAP Field Logistics",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SP11</li><li class=bullet-des-li'>Stock planned at Remote & Base</li><li class=bullet-des-li'>SP12- Stock planned at Base only</li><li class=bullet-des-li'>SP13- Stock planned at Remote only</li><li class=bullet-des-li'>SP14- Direct purchase(Non-Stock)</li><li class=bullet-des-li'>SERV- Supplier Item Logistics</li><li class=bullet-des-li'>Return cycle</li>",
    description:
      "This course covers the topics - SP11- Stock planned at Remote & Base; SP12- Stock planned at Base only; SP13- Stock planned at Remote only ; SP14- Direct purchase; SP15- Direct purchase (Non-Stock); SERV- Supplier Item Logistics. Return cycle",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "SAP MM and Logistics Execution",
    Career_levels: "",
    duration: "36",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will gain a clear understanding of different stock planning strategies, direct purchasing processes, supplier item logistics, and the return cycle, enabling efficient inventory and procurement management.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP for Oil & Gas Downstream Marketing & Logistics",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$13665/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "82",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP ABAP on HANA VT",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to HANA</li><li class=bullet-des-li'>Table Creation in HANA</li><li class=bullet-des-li'>Attribute View, Analytical View</li><li class=bullet-des-li'>Calculation View, ABAP on HANA plug-in installation</li><li class=bullet-des-li'>Open SQL, CDS Views, CDS Annotations, CDS to ODATA Service</li><li class=bullet-des-li'>External View, AMDP, AMDP BADI, ALV, Debugging/Migration tips</li><li class=bullet-des-li'>Stored Procedures, Functions</li>",
    description:
      "This course covers Introduction to HANA, Table Creation in HANA, Attribute View, Analytical View, Calculation View, ABAP on HANA plug-in installation, Open SQL, CDS Views, CDS Annotations, CDS to ODATA Service, External View, AMDP, AMDP BADI, ALV, Debugging/Migration tips, Stored Procedures, Functions",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "2 - 3 years ABAP (ECC) experience",
    Career_levels: "",
    duration: "27",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of this course, participants will be able to:Explain the impact of HANA on ABAP development.Describe how to use ECLIPSE, SAP HANA Studio, and the ABAP Development Tools (ADT).Explain the tools used for modeling in HANA and describe how to model in HANA.Describe the HANA new developments, including how HANA uses OPEN SQL and the creation/consumption of CDS and AMDP.Describe the new tools available to developers and how to use them",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Development for HANA",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$12715/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "83",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP Legacy Transfer Migration Cockpit",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to LTMC</li><li class=bullet-des-li'>LTMC - Data migration approaches and S4 HANA migration cockpit</li><li class=bullet-des-li'>Migrating Data into SAP - File approach</li><li class=bullet-des-li'>Migrating Data into SAP - staging table approach</li><li class=bullet-des-li'>S4HANA migration object modeler</li><li class=bullet-des-li'>Copying and extending delivered objects</li><li class=bullet-des-li'>Custom migration object</li><li class=bullet-des-li'>Debugging LTMC and LTMOM</li></ul>",
    description:
      "This course provides conceptual and hands on knowledge of the following topics Introduction to LTMC.LTMC - Data migration approaches and S4 HANA migration cockpit.Migrating Data into SAP - File approach.Migrating Data into SAP - staging table approach.S4HANA migration object modeler.Copying and extending delivered objects.Custom migration object.Debugging LTMC and LTMOM",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "SAP/SAP ABAP knowledge",
    Career_levels: "",
    duration: "20",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to explain concepts and do hands on for the following topics Introduction to LTMC.LTMC - Data migration approaches and S4 HANA migration cockpit.Migrating Data into SAP - File approach.Migrating Data into SAP - staging table approach.S4HANA migration object modeler.Copying and extending delivered objects.Custom migration object ",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$12352/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "84",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP Business workflow",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Business Workflow Components</li><li class=bullet-des-li'>Organization Structure</li><li class=bullet-des-li'>Business Workplace</li><li class=bullet-des-li'>SAP Workflow Customizing</li><li class=bullet-des-li'>Business Object Repository</li><li class=bullet-des-li'>Workflow Trouble shooting</li></ul>",
    description:
      "This course covers SAP Business Workflow Components, Organization Structure, Business Workplace, SAP Workflow Customizing, Business Object Repository, Workflow Trouble shooting",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "Basic ABAP programming knowledge",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to implement program workflow interfaces at various levels like objects, events, methods, rules, and attributes.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Business Workflow Management Design & Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$12103/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "85",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP ABAP on HANA Bootcamp (VT)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>conceptual and hands on knowledge of development of ABAP objects for S4HANA</li><li class=bullet-des-li'>ERP, SAP concepts Basic ABAP program</li><li class=bullet-des-li'>Data dictionary, Adobe Forms, Object Oriented ABAP</li><li class=bullet-des-li'>CDS views, AMDP, ALV IDA, Enhancements</li><li class=bullet-des-li'>Migration(LTMC), oDATA </li><li class=bullet-des-li'>basic UI application etc</li></ul>",
    description:
      "This course provides conceptual and hands on knowledge of development of ABAP objects for S4HANA . This course will help participants to explain concepts and do hands-on activities for the following topics ERP, SAP concepts Basic ABAP program, Data dictionary, Adobe Forms, Object Oriented ABAP, CDS views, AMDP, ALV IDA, Enhancements, Migration(LTMC), oDATA, basic UI application etc.",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "Basic programming knowledge",
    Career_levels: "",
    duration: "90",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of this course, participants will be able to explain concepts and do hands on for the following topics ERP, SAP concepts Basic ABAP program, Data dictionary, Adobe Forms, Object Oriented ABAP, CDS views, AMDP, ALV IDA, Enhancements, Migration(LTMC), oDATA, basic UI application etc. ",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Development for HANA",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10795/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "86",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Data",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP MDG_VT",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>MDG Introduction</li><li class=bullet-des-li'>Architecture of MDG</li><li class=bullet-des-li'>Data Modelling</li><li class=bullet-des-li'>Data modelling and SMT mapping in MDG</li><li class=bullet-des-li'>Process Modelling, Workflows</li><li class=bullet-des-li'>Business Rules</li><li class=bullet-des-li'>Customizing standard User Interface</li><li class=bullet-des-li'>Data Transfer and Replication</li><li class=bullet-des-li'>Data Quality and Search</li><li class=bullet-des-li'>Multiple-Records and Mass Processing</li><li class=bullet-des-li'>Process Analytics on S/4HANA</li><li class=bullet-des-li'>Handling custom validations and Derivations in MDG</li><li class=bullet-des-li'>Creating change requests and handling workflow management</li><li class=bullet-des-li'>Initial load and Data Replication Framework</li></ul>",
    description:
      "This course covers MDG Introduction, Architecture of MDG, Data Modelling, Data modelling and SMT mapping in MDG, Process Modelling, Workflows, Business Rules, Customizing standard User Interface, Data Transfer and Replication, Data Quality and Search, Multiple-Records and Mass Processing, Process Analytics on S/4HANA, Handling custom validations and Derivations in MDG, Creating change requests and handling workflow management,Initial load and Data Replication Framework",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge of SAP Technical or Functional modules",
    Career_levels: "",
    duration: "40",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand Simplified business process of MDG, Explain different Deployment option in MDG, Understand Concept of Data model, Staging area and Architecture principle (flex Vs reuse), Explain the concept of Work center, Change request and Work flow, Understand the concept of Process modeling, UI modeling and Business rules, Explain the concept of Data quality, Data replication and Mass processing, Explain how to handle Multi record processing and Mass processing of data under via change request, Create custom objects, Extend standard objects, Handle custom validations and Derivations, Understand Workflow management, Handle custom  scenarios in Data replication framework",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Master Data Governance MDG Tool",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10391/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "87",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP ABAP RESTful Application Programming",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Concepts of RAP, RAP architecture</li><li class=bullet-des-li'>Development of end-to-end simple application</li><li class=bullet-des-li'>Development of end-to-end application with transactional behavior</li><li class=bullet-des-li'>Extracting metadata from CDS</li></ul>",
    description:
      "This course covers Concepts of RAP, RAP architecture, Development of end-to-end simple application, Development of end-to-end application with transactional behavior, Extracting metadata from CDS",
    "MyLearning Description": "",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Hands-on experience on ABAP on HANA",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to:Explain the concepts of RAP, Explain the RAP architecture, Develop end-to-end simple application, Develop end-to-end application with transactional behavior, Extract metadata from CDS",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Development for HANA",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10177/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "88",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP ABAP on HANA Bootcamp",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>conceptual and hands on knowledge of development of ABAP objects for S4HANA</li><li class=bullet-des-li'>ERP, SAP concepts Basic ABAP program, Data dictionary</li><li class=bullet-des-li'>Adobe Forms, Object Oriented ABAP, CDS views</li><li class=bullet-des-li'>Adobe Forms, Object Oriented ABAP, CDS views</li><li class=bullet-des-li'>oDATA, basic UI application etc</li></ul>",
    description:
      "This course provides conceptual and hands on knowledge of development of ABAP objects for S4HANA . This course will help participants to explain concepts and do hands-on activities for the following topics ERP, SAP concepts Basic ABAP program, Data dictionary, Adobe Forms, Object Oriented ABAP, CDS views, Adobe Forms, Object Oriented ABAP, CDS views, oDATA, basic UI application etc.",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "Basic programming knowledge",
    Career_levels: "",
    duration: "90",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to explain concepts and do hands on for the following topics ERP, SAP concepts Basic ABAP program, Data dictionary, Adobe Forms, Object Oriented ABAP, CDS views, AMDP, ALV IDA, Enhancements, Migration(LTMC), oDATA, basic UI application etc. ",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Development for HANA",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9923/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "89",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Data",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP Business Objects Data Services Training",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Data Services Objects and Hierarchy</li><li class=bullet-des-li'>Data Services Data stores</li><li class=bullet-des-li'>Data Services Job Execution</li><li class=bullet-des-li'>Data Services Transforms</li><li class=bullet-des-li'>SQL Basics (Table/View Creations, Joins)</li><li class=bullet-des-li'>Data Services Functions</li><li class=bullet-des-li'>Data management and Assets</li></ul>",
    description:
      "This course covers Data Services Objects and Hierarchy, Data Services Data stores, Data Services Job Execution, Data Services Transforms, Data Services Functions, SQL Basics (Table/View Creations, Joins), Data management and Assets",
    learning_path: "",
    course_level: "Introductory",
    "pre-requisite": "Knowledge on data warehouse, ETL, RDBMS and SQL",
    Career_levels: "",
    duration: "36",
    mode: "Blended",
    learning_outcomes:
      "At the end of this training, participants will be able to implement, administer and manage data integration projects in SAP.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP BusinessObjects Data Services",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9317/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "90",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP Object Oriented ABAP Programming",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to OO ABAP, basic principles of OO</li><li class=bullet-des-li'>Introduction to Global class and local class, types of methods constructor method, types of attributes.</li><li class=bullet-des-li'>Concept of Exception Class</li><li class=bullet-des-li'>Advanced concepts in OO ABAP( Interface, inheritance and abstract class)</li><li class=bullet-des-li'>Introduction to  ABAP Unit testing  and design pattern  and singleton class</li></ul>",
    description:
      "This course covers:Introduction to OO ABAP, basic principles of OO. Introduction to Global class and local class, types of methods constructor method, types of attributes. Concept of Exception Class.Advanced concepts in OO ABAP( Interface, inheritance and abstract class).Introduction to  ABAP Unit testing  and design pattern  and singleton class",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "1-2 years of experience in ABAP",
    Career_levels: "",
    duration: "27",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Explain the concept of ABAP OO and basic principles of OO.Describe and create Class-Based Exception Concept.Create interface, inheritance.Write a program using  OOPS ALV. Describe  Design principles in OO ABAP and singleton pattern and create unit testing class",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Object Oriented Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$9015/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "91",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Data & Analytics",
    specialization: "SAP Data",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP Master Data Governance",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>MDG Introduction</li><li class=bullet-des-li'>Architecture of MDG</li><li class=bullet-des-li'>Data Modelling</li><li class=bullet-des-li'>Data modelling and SMT mapping in MDG</li><li class=bullet-des-li'>Process Modelling, Workflows</li><li class=bullet-des-li'>Business Rules</li><li class=bullet-des-li'>Customizing standard User Interface </li><li class=bullet-des-li'>Data Transfer and Replication</li><li class=bullet-des-li'>Data Quality and Search</li><li class=bullet-des-li'>Multiple-Records and Mass Processing</li><li class=bullet-des-li'>Process Analytics on S/4HANA</li><li class=bullet-des-li'>Handling custom validations and Derivations in MDG</li><li class=bullet-des-li'>Creating change requests and handling workflow management</li><li class=bullet-des-li'>Initial load and Data Replication Framework</li></ul>",
    description:
      "This course covers MDG Introduction, Architecture of MDG, Data Modelling, Data modelling and SMT mapping in MDG, Process Modelling, Workflows, Business Rules, Customizing standard User Interface, Data Transfer and Replication, Data Quality and Search, Multiple-Records and Mass Processing, Process Analytics on S/4HANA, Handling custom validations and Derivations in MDG, Creating change requests and handling workflow management, Initial load and Data Replication Framework",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Knowledge of SAP Technical or Functional modules",
    Career_levels: "",
    duration: "40",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Understand Simplified business process of MDG, Explain different Deployment option in MDG, Understand Concept of Data model, Staging area and Architecture principle (flex Vs reuse), Explain the concept of Work center, Change request and Work flow, Understand the concept of Process modeling, UI modeling and Business rules, Explain the concept of Data quality, Data replication and Mass processing, Explain how to handle Multi record processing and Mass processing of data under via change request, Create custom objects, Extend standard objects, Handle custom validations and Derivations, Understand Workflow management, Handle custom  scenarios in Data replication framework",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Master Data Governance MDG Tool",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$8217/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "92",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP NetWeaver Gateway OData Services",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Gateway 2.0 architecture</li><li class=bullet-des-li'>Creation and Consumption of ODATA services</li><li class=bullet-des-li'>Various ODATA services deployment options</li><li class=bullet-des-li'>SAP Gateway service extensibility</li><li class=bullet-des-li'>Function Imports</li><li class=bullet-des-li'>Deep Insert</li><li class=bullet-des-li'>Implementation of Expand</li><li class=bullet-des-li'>eTags, Batch Processing</li><li class=bullet-des-li'>Offline Support</li><li class=bullet-des-li'>Media links</li></ul>",
    description:
      "This Course covers SAP Gateway 2.0 architecture, Creation and Consumption of ODATA services, Various ODATA services deployment options, SAP Gateway service extensibility, Function Imports, Deep Insert, Implementation of Expand, eTags, Batch Processing, Offline Support and Media links",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "ABAP knowledge",
    Career_levels: "",
    duration: "36",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Explain Gateway and its deployment, Describe ODATA and performing ODATA operations and queries, Define data model and implement CRUD operations, Extend SAP Gateway services and build new ones with CDS Views, Handle security and consume OData services using SAP Web IDE",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$13906/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "93",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP LTMC(VT)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Introduction to LTMC</li><li class=bullet-des-li'>LTMC - Data migration approaches and S4 HANA migration cockpit</li><li class=bullet-des-li'>Migrating Data into SAP - File approach</li><li class=bullet-des-li'>Migrating Data into SAP - staging table approach</li><li class=bullet-des-li'>S4HANA migration object modeler</li><li class=bullet-des-li'>Copying and extending delivered objects</li><li class=bullet-des-li'>Custom migration object</li><li class=bullet-des-li'>Debugging LTMC and LTMOM</li></ul>",
    description:
      "This course provides conceptual and hands on knowledge of the following topics Introduction to LTMC, LTMC - Data migration approaches and S4 HANA migration cockpit, Migrating Data into SAP - File approach, Migrating Data into SAP - staging table approach, S4HANA migration object modeler, Copying and extending delivered objects, Custom migration object, Debugging LTMC and LTMOM",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "SAP/SAP ABAP knowledge",
    Career_levels: "",
    duration: "20",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of this course, participants will be able to explain concepts and do hands on for the following topics Introduction to LTMC, LTMC - Data migration approaches and S4 HANA migration cockpit, Migrating Data into SAP - File approach, Migrating Data into SAP - staging table approach, S4HANA migration object modeler, Copying and extending delivered objects, Custom migration object ",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$11971/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "94",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP NetWeaver Gateway OData Services(VT)",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SAP Gateway 2.0 architecture</li><li class=bullet-des-li'>Creation and Consumption of ODATA services</li><li class=bullet-des-li'>Various ODATA services deployment options</li><li class=bullet-des-li'>SAP Gateway service extensibility</li><li class=bullet-des-li'>Function Imports</li><li class=bullet-des-li'>Deep Insert</li><li class=bullet-des-li'>Implementation of Expand</li><li class=bullet-des-li'>eTags, Batch Processing</li><li class=bullet-des-li'>Offline Support</li><li class=bullet-des-li'>Media links</li></ul>",
    description:
      "This Course covers SAP Gateway 2.0 architecture, Creation and Consumption of ODATA services, Various ODATA services deployment options, SAP Gateway service extensibility, Function Imports, Deep Insert, Implementation of Expand, eTags, Batch Processing, Offline Support and Media links",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "ABAP knowledge",
    Career_levels: "",
    duration: "36",
    mode: "Instructor Led",
    learning_outcomes:
      "At the end of this course, participants will be able to Explain Gateway and its deployment, Describe ODATA and performing ODATA operations and queries, Define data model and implement CRUD operations, Extend SAP Gateway services and build new ones with CDS Views, Handle security and consume OData services using SAP Web IDE",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Development",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$13906/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "95",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "Demystifying SAP BTP",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>SAP BTP enables to leverage the power of generative AI for development, automation, integration, data management, and analytics across SAP and non-SAP systems</li><li class=bullet-des-li'>streamline system integration</li><li class=bullet-des-li'>minimize development efforts</li><li class=bullet-des-li'>speed up time-to-value through pre-built workflows and integrations</li></ul>",
    description:
      "This course covers SAP BTP enables to leverage the power of generative AI for development, automation, integration, data management, and analytics across SAP and non-SAP systems. It helps streamline system integration, minimize development efforts, and speed up time-to-value through pre-built workflows and integrations.Enhance developer efficiency, automate complex processes, and seamlessly incorporate the latest AI models into your applications with security and scalability.Topics covered include SAP BTP Introduction, Why SAP BTP, SAP Build, RISE with SAP, Clean Core, BTP Accelerators, Pricing Models, Joule Capabilities, and BTP Business AI.",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Good to have basic knowledge of SAP",
    Career_levels: "",
    duration: "9",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course you will be able to understand SAP BTP capabilities.",
    ssi_skill_id: "",
    "ssi_skill name": "SAP BTP Build Low-Code",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$14149/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "96",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Technology",
    specialization: "SAP Development",
    landscape: "",
    course_code: "",
    course_image: "img-16",
    course_name: "SAP ABAP Cloud Development",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Clean Core and SAP Extensibility overview</li><li class=bullet-des-li'>SAP ABAP Cloud Development Model and BTP Overview</li><li class=bullet-des-li'>Restful ABAP programming model</li><li class=bullet-des-li'>Transport Management in SAP ABAP Cloud</li><li class=bullet-des-li'>Event Mesh, Event consumption in ADT,RAP Business Events</li><li class=bullet-des-li'>Consuming Remote API’s, BAPI’s, BTP services</li><li class=bullet-des-li'>Authorization concepts and IAM</li><li class=bullet-des-li'>HANA Migration cockpit , RAP Facade , RAP Extension</li><li class=bullet-des-li'>EML ,application jobs, XCO libraries</li><li class=bullet-des-li'>Mitigating Tier 1 API's in Tier 2, Governing Tier 2 API's, API Snapshots</li></ul>",
    description:
      "This course provides overview of SAP BTP and ABAP on BTP with below topics:Clean Core and SAP Extensibility overview, SAP ABAP Cloud Development Model and BTP Overview, Restful ABAP programming model, Transport Management in SAP ABAP Cloud, Event Mesh, Event consumption in ADT,RAP Business Events, Consuming Remote API’s, BAPI’s, BTP services, Authorization concepts and IAM, HANA Migration cockpit , RAP Facade , RAP Extension, EML ,application jobs, XCO libraries, Mitigating Tier 1 API's in Tier 2, Governing Tier 2 API's, API Snapshots",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "SAP ABAP on HANA knowledge",
    Career_levels: "",
    duration: "36",
    mode: "Blended",
    learning_outcomes:
      "At the end of the course participants will be able to understand, explain and gain hands on experience on Clean Core and SAP Extensibility overview, SAP ABAP Cloud Development Model and BTP Overview, Restful ABAP programming model, Transport Management in SAP ABAP Cloud, Event Mesh, Event consumption in ADT,RAP Business Events, Consuming Remote API’s, BAPI’s, BTP services, Authorization concepts and IAM, HANA Migration cockpit , RAP Facade , RAP Extension, EML ,application jobs, XCO libraries,Mitigating Tier 1 API's in Tier 2, Governing Tier 2 API's, API Snapshots",
    ssi_skill_id: "",
    "ssi_skill name": "SAP ABAP Cloud",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17815$10627/rel-task/2997$10951.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
  {
    sno: "97",
    type: "Technology",
    platform: "SAP",
    domain: "SAP Supply Chain & Operations",
    specialization: "SAP Sales",
    landscape: "",
    course_code: "ATCI-LTT-SAP-LT-BLC-0048",
    course_image: "img-16",
    course_name: "SAP S/4HANA Sales",
    bulleted_description:
      " <ul class='bullet-des-ul'><li class='bullet-des-li'>Database architecture of HANA</li><li class=bullet-des-li'>Journey of SAP S4HANA, SAP S/4HANA LOB solutions</li><li class=bullet-des-li'>SAP Cloud Platform, Cloud Applications with SAP – Hybris</li><li class=bullet-des-li'>Ariba, Cloud for Customers, Cloud for Services</li><li class=bullet-des-li'>CVI Integration Process, Simplified Data Flow model</li><li class=bullet-des-li'>Configurations in New IMG for Settlement Management</li><li class=bullet-des-li'>Configuration and new tables for Business Partner</li><li class=bullet-des-li'>User Experience Related Design Decisions</li><li class=bullet-des-li'>Development Methodology in RICEFW</li><li class=bullet-des-li'>Data migration plan, Migrations Tools</li></ul>",
    description:
      "This course covers Database architecture of HANA, Journey of SAP S4HANA, SAP S/4HANA LOB solutions, SAP Cloud Platform, Cloud Applications with SAP – Hybris, Ariba, Cloud for Customers, Cloud for Services, CVI Integration Process, Simplified Data Flow model, Configurations in New IMG for Settlement Management, Configuration and new tables for Business Partner, User Experience Related Design Decisions, Development Methodology in RICEFW, Data migration plan, Migrations Tools",
    learning_path: "",
    course_level: "Intermediate",
    "pre-requisite": "Experience in SAP SD Module on ECC",
    Career_levels: "",
    duration: "18",
    mode: "Blended",
    learning_outcomes:
      "At the end of this course, participants will be able to Acquire a good understanding of SAP S/4HANA Sales Functionalities, Distinguish between the features of Traditional SAP ECC system Vs. SAP S/4HANA, Summarize the new innovations in SAP’s S/4HANA latest version, Utilize the conceptual knowledge obtained in the session, in your day to day work, Practice the new features of SAP S/4HANA in Test System on S4HANA in your project, Apply the new SAP learnings into your Functional or Consulting roles at your client place",
    ssi_skill_id: "",
    "ssi_skill name": "SAP Sales and Distribution (SD)",
    ssi_skill2_id: "",
    "ssi_skill2 name": "",
    ssi_skill3_id: "",
    "ssi_skill3 name": "",
    mylearning_url:
      "https://wd103.myworkday.com/accenture/email-universal/inst/17816$456/rel-task/2998$29489.htmld",
    additional_url: "",
    lsc_link: "",
    remarks: "",
    "lead/poc": "",
    program_type: "",
  },
];
export default SapDomainData2;
